<template>
  <div class="main-content bg-pos">
    <!-- Navbar -->
    <NavbarPos :userLogin="userlogin" :shopSetting="shop_setting" />
    <BlockUI v-if="busy">
      <div class="loader"></div>
    </BlockUI>
    <div id="el-banner"></div>
    <!-- Page content -->
    <div class="container-fluid pb-5 pos">
      <slide-y-up-transition mode="out-in" origin="center top">
        <div class="row justify-content-center">
          <!-- box-รายการสินค้า -->
          <div class="col-md-6 col-xl">
            <div class="cart-product bg-white bd-radius-5 p-0">
              <b-tabs card>
                <b-tab title active>
                  <template v-slot:title>
                    <div class="my-3 h3 px-3">
                      เลือกบริการขนส่ง
                      <b-badge
                        v-if="sender.name != '' && sender.identity == false"
                        variant="success">
                        ยืนยันตัวตนแล้ว
                      </b-badge>
                      <b-badge v-else-if="sender.identity" variant="success">
                        ยืนยัน COD แล้ว
                      </b-badge>
                      <b-badge v-else variant="warning"
                        >ไม่ได้ยืนยันตัวตน</b-badge
                      >
                    </div>
                  </template>
                  <div class="row">
                    <div class="col-12">
                      <b-form-group
                        id="input-group-1"
                        label-for="input-search-couier"
                        class="mb-0 w-100">
                        <b-form-input
                          id="input-search-couier"
                          type="text"
                          v-model="searchCourier"
                          placeholder="ค้นหาขนส่ง"
                          class="search-pos s-courier"></b-form-input>
                        <b-input-group-append class="search-pos s-icon">
                          <i class="fas fa-search"></i>
                        </b-input-group-append>
                      </b-form-group>
                    </div>
                  </div>
                  <b-card-text class="p-0 scroll-bar-pop card-tab">
                    <div class="row mb-3">
                      <div class="col-12">
                        <b-button size="sm" variant="outline-secondary" pill>
                          <i class="fas fa-stream"></i> ฉบับร่าง
                        </b-button>
                      </div>
                    </div>
                    <div class="row">
                      <div
                        class="col-12 col-lg-6 col-xl-3 mb-3"
                        v-if="permission.dropoffShippop">
                        <CardPos
                          :courier="{
                            title: 'DROP OFF(ลทบ / EMS)',
                            name: 'SHIPPOP DROP OFF',
                            icon: 'shippop-logo',
                          }"
                          :class="{
                            disabled: idorder,
                            lockcourier: lockDropoffShippop,
                          }"
                          @click.native="openModal(DROPOFF_SP, false)" />
                      </div>
                      <div
                        class="col-12 col-lg-6 col-xl-3 mb-3"
                        v-if="permission.dropoffVRich">
                        <CardPos
                          :courier="{
                            title: 'DROP OFF (V RICH)',
                            name: 'V RICH DROP OFF',
                            icon: 'vrich-logo.png',
                          }"
                          :class="{
                            disabled: idorder,
                            lockcourier: lockDropoffVRich,
                          }"
                          @click.native="
                            courierModalTime(courierDropoffVRich, ''),
                              (dropoffVRich.show = true)
                          " />
                      </div>
                      <div
                        class="col-12 col-lg-6 col-xl-3 mb-3"
                        v-if="permission.dropoffEasyShip">
                        <CardPos
                          :courier="{
                            title: 'DROP OFF (EASYSHIP)',
                            name: 'EASYSHIP DROP OFF',
                            icon: 'easyship-logo.png',
                          }"
                          :class="{
                            disabled: idorder,
                            lockcourier: lockDropoffEasyShip,
                          }"
                          @click.native="
                            courierModalTime(courierDropoffEasyShip, ''),
                              (dropoffEasyShip.show = true)
                          " />
                      </div>
                      <div
                        class="col-12 col-lg-6 col-xl-3 mb-3"
                        v-if="permission.kerryDropoff">
                        <CardPos
                          :courier="{
                            title: 'Kerry Drop off',
                            name: 'Kerry Drop off',
                            icon: 'kerry-dropoff-logo.png',
                          }"
                          :class="{
                            disabled: idorder,
                            lockcourier: lockKerryDropoff,
                          }"
                          @click.native="openModal(KERRY_DROPOFF, false)" />
                        <!-- @click.native="courierModalTime( courierDropoffEasyShip , '' ) , dropoffEasyShip.show = true" -->
                      </div>
                      <div
                        class="col-12 col-lg-6 col-xl-3 mb-3"
                        v-if="permission.dropoffQuick">
                        <CardPos
                          :courier="{
                            title: 'DROP OFF (QUICK EXPRESS)',
                            name: 'QUICK EXPRESS DROP OFF',
                            icon: 'quick-logo.png',
                          }"
                          :class="{
                            disabled: idorder,
                            lockcourier: lockDropoffQuick,
                          }"
                          @click.native="
                            courierModalTime(courierDropoffQuick, ''),
                              (dropoffQuick.show = true)
                          " />
                      </div>
                      <template v-for="courier in courierFilter">
                        <div
                          v-if="showCourier(courier)"
                          class="col-12 col-lg-6 col-xl-3 mb-3"
                          :key="courier.id">
                          <CardPos
                            v-if="
                              courier.shippop == 1 && courier.prebarcode == 0
                            "
                            :courier="courier"
                            :class="{ disabled: idorder, lockcourier: lock }"
                            @click.native="courierModalTime(courier, '')" />
                          <CardPos
                            v-else-if="courier.shippop == 0"
                            :courier="courier"
                            :class="{
                              disabled: idorder,
                              lockcourier: lockCourierGen,
                            }"
                            @click.native="courierModalTime(courier, '')" />
                          <CardPos
                            v-else
                            :courier="courier"
                            :class="{ disabled: idorder, lockcourier: lockpre }"
                            @click.native="
                              courierModalTime(courier, 'prebarcode')
                            " />
                        </div>
                      </template>
                    </div>
                  </b-card-text>
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    <div class="my-3 h3 px-3">เลือกผลิตภัณฑ์</div>
                  </template>
                  <div class="row">
                    <div class="col-12">
                      <b-form-group
                        id="input-group-1"
                        label-for="input-1"
                        class="mb-3 w-100">
                        <b-form-input
                          id="input-1"
                          type="text"
                          v-model="searchProduct"
                          placeholder="ค้นหาผลิตภัณฑ์"
                          class="s-product search-pos"></b-form-input>
                        <b-input-group-append class="search-pos s-icon">
                          <i class="fas fa-search"></i>
                        </b-input-group-append>
                      </b-form-group>
                    </div>
                  </div>
                  <b-card-text class="p-0 scroll-bar-pop card-tab">
                    <draggable
                      v-bind="dragOptions"
                      v-model="products"
                      class="row"
                      v-if="isAdmin()">
                      <div
                        class="col-xl-3 col-md-6 col-lg-6 mb-3"
                        v-for="product in productFilter"
                        :key="product.id">
                        <CardItems
                          v-on:add-to-cart="addToCart(product)"
                          :class="{ disabled: idorder }"
                          :product="product" />
                      </div>
                    </draggable>
                    <div class="row" v-else>
                      <div
                        class="col-xl-3 col-md-6 col-lg-6 mb-3"
                        v-for="product in productFilter"
                        :key="product.id">
                        <CardItems
                          v-on:add-to-cart="addToCart(product)"
                          :class="{ disabled: idorder }"
                          :product="product" />
                      </div>
                    </div>
                  </b-card-text>
                  <!-- <button
                    v-if="isAdmin()"
                    class="btn btn-warning btn-block btn-icon py-3"
                    @click="moveProduct()">
                    บันทึกตำแหน่ง
                  </button> -->
                </b-tab>
              </b-tabs>
            </div>
          </div>
          <InterParcelService
            :setting="interParcelService"
            :confirmFunc="addOrderInterParcel" />

          <!-- box-ตารางสินค้า -->
          <div class="col-md-6 col-xl-5 pos-r-lg-max">
            <div class="bg-white bd-radius-5">
              <div class="row">
                <div class="col-12">
                  <div class="table">
                    <div class="card-header border-0 dark">
                      <div class="row align-items-center">
                        <div class="col-8 text-truncate">
                          <h3 class="mb-3 dark">
                            รายการสินค้า {{ sender.name }}
                          </h3>
                        </div>
                        <div class="col-4 pl-1 pr-0">
                          <button
                            class="btn btn-block py-1 px-0"
                            :class="
                              $THEME.btnCancelBill && !idorder && cart.length
                                ? 'btn-danger'
                                : 'btn-newbill'
                            "
                            :disabled="total == 0 && sender.name == ''"
                            @click="modalConfirmReset()">
                            <i
                              class="fas fa-circle-notch fa-spin"
                              v-if="isLoadingNewBill"></i>
                            {{
                              $THEME.btnCancelBill && !idorder && cart.length
                                ? "ยกเลิกรายการทั้งหมด"
                                : "เปิดบิลใหม่"
                            }}
                          </button>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <b-form-group
                            label-for="input-search-recipient"
                            class="mt-2 mb-3 w-100">
                            <b-input-group>
                              <b-input-group-prepend is-text>
                                <i class="fa fa-search text-muted"></i>
                              </b-input-group-prepend>
                              <b-form-input
                                type="search"
                                placeholder="ค้นหาพัสดุด้วยข้อมูลผู้รับ (ชื่อ, เบอร์โทร)"
                                v-model="search.recipient"></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </div>
                      </div>
                      <div
                        class="scroll-table scroll-bar-pop scrollbar-style table-responsive">
                        <h3
                          class="scroll-empty"
                          v-if="total == 0 && !filterCheckKerryDropoff">
                          กรุณาเพิ่มสินค้า
                        </h3>
                        <table class="table" v-else>
                          <thead>
                            <tr class="text-center">
                              <th>#</th>
                              <th :class="checkThemeQuick() ? 'px-5' : ''">
                                ชื่อสินค้า
                              </th>
                              <th class="px-5">ข้อมูลผู้รับ</th>
                              <th>จำนวน</th>
                              <th>ราคา</th>
                              <th>ราคารวม</th>
                              <th>ยอด COD</th>
                              <th>จัดการ</th>
                            </tr>
                          </thead>
                          <tbody>
                            <template
                              v-for="(item, index) in search.recipient
                                ? filteredCartShippingByRecipient
                                : cartShipping">
                              <tr
                                :key="index"
                                :class="[
                                  'text-center',
                                  {
                                    'tr-error-after-create-order-details':
                                      item.error.status,
                                  },
                                  {
                                    'tr-printlabel-after-create-order-details':
                                      item.order_detail_id,
                                  },
                                ]">
                                <td :rowspan="item.error.status ? 2 : ''">
                                  {{ getIndex(0, index) }}
                                </td>
                                <td :rowspan="item.error.status ? 2 : ''">
                                  <template
                                    v-if="item.hasOwnProperty('dropoff_type')">
                                    {{
                                      item.dropoff_type == "VRICH_DROPOFF" ||
                                      item.dropoff_type == "QUICK_DROPOFF"
                                        ? item.pre_tracking
                                        : item.dropoff_tracking_code
                                    }}
                                    {{
                                      checkShowWeightCart(item)
                                        ? checkUntiKG()
                                          ? item.parcel.weightKG + "kg"
                                          : item.parcel.weight + "g"
                                        : ""
                                    }}
                                  </template>
                                  <template v-else>
                                    {{ item.name }}
                                    {{
                                      checkShowWeightCart(item)
                                        ? checkUntiKG()
                                          ? item.parcel.weightKG + "kg"
                                          : item.parcel.weight + "g"
                                        : ""
                                    }}
                                  </template>

                                  <br />
                                  <b-badge
                                    v-if="item.hasOwnProperty('dropoff_type')"
                                    variant="primary"
                                    class="d-block">
                                    {{ item.dropoff_type }}
                                  </b-badge>
                                  <b-badge
                                    v-if="item.cod_amount > 0"
                                    variant="info"
                                    class="d-block">
                                    COD
                                  </b-badge>
                                  <!-- <template v-if="insurance.listPrice.price > 0">
                                    <br />
                                    <span class="small">- ค่าบริการประกันพัสดุ</span>
                                  </template> -->
                                </td>
                                <td>
                                  {{ item.to.name }} <br />
                                  {{ item.to.tel }}
                                </td>
                                <td>{{ item.num }}</td>
                                <td>{{ item.price | numFormat("0,0.00") }}</td>
                                <td>
                                  {{
                                    (item.price +
                                      item.rate_remote_area +
                                      item.cross_price +
                                      (item.insurance &&
                                      item.insurance.listPrice.price > 0
                                        ? item.insurance.listPrice.price
                                        : 0))
                                      | numFormat("0,0.00")
                                  }}
                                  <br v-if="item.rate_remote_area > 0" />
                                  <span
                                    class="small text-danger tooltip-target-1"
                                    v-if="item.rate_remote_area > 0"
                                    v-b-tooltip
                                    title="ค่าบริการพิ้นที่พิเศษ"
                                    >(+ {{ item.rate_remote_area }})</span
                                  >
                                  <br v-if="item.cross_price > 0" />
                                  <span
                                    class="small text-danger tooltip-target-1"
                                    v-if="item.cross_price > 0"
                                    v-b-tooltip
                                    title="ค่าบริการข้ามภาค"
                                    >(+ {{ item.cross_price }})</span
                                  >
                                  <template
                                    v-if="
                                      item.insurance &&
                                      item.insurance.listPrice.price > 0
                                    ">
                                    <br />
                                    <span
                                      class="small text-danger tooltip-target-1"
                                      v-b-tooltip
                                      title="ค่าบริการประกันพัสดุ"
                                      >(+
                                      {{
                                        item.insurance.listPrice.price
                                      }})</span
                                    >
                                  </template>
                                </td>
                                <td>
                                  {{ item.cod_amount | numFormat("0,0.00") }}
                                </td>
                                <td>
                                  <div class="d-flex">
                                    <button
                                      v-if="checkThemeQuick()"
                                      class="btn btn-link text-indigo p-2 hvr-grow"
                                      :disabled="filterCheckKerryDropoff"
                                      @click="switchPrintLabel(item)">
                                      <i class="fas fa-print"></i>
                                    </button>

                                    <button
                                      v-else
                                      class="btn btn-link text-info p-2 hvr-grow"
                                      :disabled="
                                        idorder != '' || filterCheckKerryDropoff
                                      "
                                      @click="editParcel(item.check)">
                                      <i class="fas fa-edit"></i>
                                    </button>

                                    <button
                                      class="btn btn-link text-danger p-2 hvr-grow"
                                      :disabled="idorder != ''"
                                      @click="
                                        checkBeforeRemoveTotal(item.check)
                                      ">
                                      <i class="far fa-trash-alt"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                              <tr
                                :key="`error-msg-${index}`"
                                v-if="item.error.status">
                                <td
                                  colspan="6"
                                  class="text-center tr-error-after-create-order-msg">
                                  {{ item.error.msg }}
                                </td>
                              </tr>
                            </template>
                            <template v-for="(item, index) in cartItem">
                              <tr :key="item.id" class="text-center">
                                <td>
                                  {{ getIndex(cartShipping.length, index) }}
                                </td>
                                <td>{{ item.name }}</td>
                                <td>-</td>
                                <td>
                                  <number-input
                                    size="small"
                                    @change="reload(item)"
                                    v-model="item.num"
                                    :min="1"
                                    inline
                                    controls
                                    class="input-product-table"
                                    :disabled="idorder != ''"></number-input>
                                </td>
                                <td>{{ item.price | numFormat("0,0.00") }}</td>
                                <td>
                                  {{ item.qtytotal | numFormat("0,0.00") }}
                                </td>
                                <td>{{ "-" }}</td>
                                <td>
                                  <button
                                    class="btn btn-link text-danger hvr-grow"
                                    :disabled="idorder != ''"
                                    @click="removeTotal(item.check)">
                                    <i class="far fa-trash-alt"></i>
                                  </button>
                                </td>
                              </tr>
                            </template>
                            <template v-for="(item, index) in cartService">
                              <tr :key="item.check" class="text-center">
                                <td>
                                  {{
                                    getIndex(
                                      cartShipping.length + cartItem.length,
                                      index
                                    )
                                  }}
                                </td>
                                <td>
                                  <template
                                    v-if="item.name === 'shippop inter parcel'">
                                    {{ item.trackingCode }}<br />
                                    <div class="overflow-table-order">
                                      <span class="small">{{ item.from }}</span>
                                      <br />
                                      <span class="small text-info">{{
                                        "(พัสดุต่างประเทศ)"
                                      }}</span>
                                    </div>
                                  </template>
                                  <template v-else>
                                    {{ item.name }}
                                  </template>
                                </td>
                                <td>-</td>
                                <td>{{ item.num }}</td>
                                <td>{{ item.price | numFormat("0,0.00") }}</td>
                                <td>{{ item.price | numFormat("0,0.00") }}</td>
                                <td>{{ "-" }}</td>
                                <td>
                                  <button
                                    class="btn btn-link text-danger hvr-grow"
                                    :disabled="idorder != ''"
                                    @click="removeTotal(item.check)">
                                    <i class="far fa-trash-alt"></i>
                                  </button>
                                </td>
                              </tr>
                            </template>
                            <template
                              v-for="(item, index) in cartDropoffShippop">
                              <tr :key="index" class="text-center">
                                <td>
                                  {{
                                    getIndex(
                                      cartShipping.length +
                                        cartItem.length +
                                        cartService.length,
                                      index
                                    )
                                  }}
                                </td>
                                <td>{{ item.barcode }}</td>
                                <td>-</td>
                                <td>{{ "1" }}</td>
                                <td>{{ "-" }}</td>
                                <td>{{ item.price | numFormat("0,0.00") }}</td>
                                <td>{{ "-" }}</td>
                                <td>
                                  <button
                                    class="btn btn-link text-danger hvr-grow"
                                    :disabled="idorder != ''"
                                    @click="removeTotal(index, DROPOFF_SP)">
                                    <i class="far fa-trash-alt"></i>
                                  </button>
                                </td>
                              </tr>
                            </template>
                            <template v-for="(item, index) in cartInsurance">
                              <tr :key="item.check" class="text-center">
                                <td>
                                  {{
                                    getIndex(
                                      cartShipping.length +
                                        cartItem.length +
                                        cartService.length +
                                        cartDropoffShippop.length,
                                      index
                                    )
                                  }}
                                </td>
                                <td>{{ item.name }}</td>
                                <td>-</td>
                                <td>{{ item.num }}</td>
                                <td>{{ item.price | numFormat("0,0.00") }}</td>
                                <td>{{ item.price | numFormat("0,0.00") }}</td>
                                <td>{{ "-" }}</td>
                                <td>
                                  <button
                                    class="btn btn-link text-danger hvr-grow"
                                    :disabled="idorder != ''"
                                    @click="removeTotal(item.check)">
                                    <i class="far fa-trash-alt"></i>
                                  </button>
                                </td>
                              </tr>
                            </template>
                            <template v-for="(item, index) in cartEVoucher">
                              <tr :key="item.check" class="text-center">
                                <td>
                                  {{
                                    getIndex(
                                      cartShipping.length +
                                        cartItem.length +
                                        cartService.length +
                                        cartDropoffShippop.length +
                                        cartInsurance.length,
                                      index
                                    )
                                  }}
                                </td>
                                <td>
                                  {{ item.name }}
                                  <br />
                                  <span class="small"
                                    >({{ item.barcode }})</span
                                  >
                                </td>
                                <td>-</td>
                                <td>{{ item.num }}</td>
                                <td>{{ item.price | numFormat("0,0.00") }}</td>
                                <td>{{ item.price | numFormat("0,0.00") }}</td>
                                <td>{{ "-" }}</td>
                                <td>
                                  <button
                                    class="btn btn-link text-danger hvr-grow"
                                    :disabled="idorder != ''"
                                    @click="removeTotal(item.check)">
                                    <i class="far fa-trash-alt"></i>
                                  </button>
                                </td>
                              </tr>
                            </template>
                            <template v-for="(item, index) in cartZendai">
                              <tr :key="item.check" class="text-center">
                                <td>
                                  {{
                                    getIndex(
                                      cartShipping.length +
                                        cartItem.length +
                                        cartService.length +
                                        cartDropoffShippop.length +
                                        cartInsurance.length +
                                        cartEVoucher.length,
                                      index
                                    )
                                  }}
                                </td>
                                <td>{{ item.name }}</td>
                                <td>-</td>
                                <td>{{ item.num }}</td>
                                <td>{{ item.price | numFormat("0,0.00") }}</td>
                                <td>{{ item.price | numFormat("0,0.00") }}</td>
                                <td>{{ "-" }}</td>
                                <td>
                                  <button
                                    class="btn btn-link text-danger hvr-grow"
                                    :disabled="idorder != ''"
                                    @click="removeTotal(item.check)">
                                    <i class="far fa-trash-alt"></i>
                                  </button>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="group-result">
                      <div class="price">
                        <h6>
                          ยอดรวมทั้งหมด
                          <small v-if="idorder && checkBill.discountAmount > 0"
                            >(รวมส่วนลด)</small
                          >
                        </h6>
                        <h1>
                          <template
                            v-if="idorder && checkBill.discountAmount > 0">
                            <span class="text-muted number-discount px-2">{{
                              total | numFormat("0,0.00")
                            }}</span>
                            <span
                              >{{
                                (total - checkBill.discountAmount)
                                  | numFormat("0,0.00")
                              }}
                            </span>
                          </template>
                          <template v-else>
                            {{ total | numFormat("0,0.00") }}
                          </template>
                          <small>บาท</small>
                        </h1>
                      </div>
                    </div>
                    <!-- <div class="w-100 px-3" role="group" aria-label="Basic example">
                      <button
                        type="button"
                        :disabled="total == 0 || idorder != '' || ( filterCheckOrderDetailId && !filterCheckDropoffVRich )"
                        class="btn btn-success py-3 btn-block"
                        @click="beforeCheckbill()"
                      >รับเงิน</button> -->
                    <!-- v-b-modal.modal-checkbill -->
                    <!-- </div> -->
                  </div>
                  <div class="col-12">
                    <div class="group-btn-etc row p-3 mt-1">
                      <div class="col-3 px-2">
                        <router-link
                          :to="`/receipt/${idorder}`"
                          target="_blank">
                          <button
                            class="btn btn-receipt btn-block py-3"
                            :disabled="!idorder">
                            <!-- <i class="far fa-file-alt"></i>  -->
                            ใบเสร็จ
                          </button>
                        </router-link>
                      </div>
                      <div class="col px-2">
                        <button
                          type="button"
                          :disabled="
                            (total == 0 && !filterCheckKerryDropoff) ||
                            idorder != '' ||
                            (filterCheckOrderDetailId &&
                              !filterCheckDropoffVRich &&
                              !filterCheckKerryDropoff &&
                              !filterCheckDropoffQuick)
                          "
                          class="btn btn-success py-3 btn-block"
                          @click="beforeCheckbill()">
                          รับเงิน
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- modal เลือกขนส่ง cod -->
          <CodCourierList
            :cod="cod_details"
            :func="modalOrders"></CodCourierList>
          <!-- modal dropoff cod -->
          <DropoffShippop
            :dropoff="dropoffShippopDetails"
            :confirm="addDropoffShippopOrder"></DropoffShippop>
          <!-- modal kerry dropoff -->
          <KerryDropoff
            ref="kerryDropoff"
            :kerryDropoff="kerryDropoff"
            :count.sync="count"
            :addressFrom="from"
            :cartKerryDropoff="cartKerryDropoff"
            @confirmCreateKerryDropoff="confirmCreateKerryDropoff($event)" />

          <!-- modal เพิ่มรายการพัสดุ -->
          <TableAddOrders
            :orders="addMoreOrder"
            :func="{
              createOrder: handleModalCreateOrder,
              editOrder: editParcel,
              closeModal: closeParcel,
              confirmOrder: confirmShipping,
            }"
            @editorder="editParcel">
          </TableAddOrders>
          <!-- <TableAddOrders :orders="addMoreOrder" @editParcel="editParcel()"
            :func="{ 'createOrder' : handleModalCreateOrder  }" >
          </TableAddOrders> -->
          <!-- Modal ประกันเสริม -->
          <ModalInsurance
            ref="insurance"
            :insuranceService="insuranceService"
            @addInsurance="addInsurance()"
            @clearInsurance="clearInsurance()" />
          <!-- Modal บริการเสริม -->
          <ModalService :fee="fee" @addService="addService()" />
          <!-- Modal พื้นที่ห่างไกล -->
          <ModalAlertRemoteArea
            :remoteArea="remote_area"
            :crossPrice="crossPrice" />

          <!-- Modal E-Voucher-->
          <ModalShabuEVoucher
            ref="shabu"
            :shabuEVoucher="shabuEVoucher"
            @addShabuEVoucher="addShabuEVoucher()"
            @clearShabuEVoucher="clearShabuEVoucher()" />

          <!-- Modal Zendai-->
          <ModalZendai
            ref="zendai"
            :zendai="zendai"
            :sender="sender"
            @addZendai="addZendai()" />

          <!-- Modal พัสดุ -->
          <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            ref="model-parcel"
            id="model-parcel"
            @close="closeParcel"
            size="lg"
            hide-footer
            no-stacking>
            <!-- :no-stacking="(checkThemeQuick()) ? false : true" -->
            <template slot="modal-title" class="w-100">
              <div
                slot="header"
                class="bg-white border-0"
                ref="model-parcel-header">
                <div class="row align-items-center">
                  <div class="col-6 d-flex align-items-center">
                    <h3 class="mb-0">
                      ข้อมูลการจัดส่ง
                      <span v-if="iconUrl.status == false">{{
                        iconUrl.courierName
                      }}</span>
                    </h3>

                    <img
                      v-if="
                        iconUrl.status != false &&
                        !checkDropoffVRich() &&
                        !checkDropoffEasyShip() &&
                        !checkDropoffQuick()
                      "
                      class="card-img-top img-mx-50 pl-3"
                      :src="iconUrl.url"
                      img-alt="Image" />

                    <img
                      v-if="checkDropoffVRich()"
                      class="card-img-top img-mx-100 pl-3"
                      src="img/courier_icons/vrich-logo.png"
                      img-alt="ImageVRich" />

                    <img
                      v-if="checkDropoffQuick()"
                      class="card-img-top img-mx-100 pl-3"
                      src="img/courier_icons/quick-logo.png"
                      img-alt="ImageQuick" />

                    <img
                      v-if="checkDropoffEasyShip()"
                      class="card-img-top img-mx-100 pl-3"
                      src="img/courier_icons/easyship-logo.png"
                      img-alt="ImageEasyShip" />
                  </div>
                </div>
              </div>
            </template>
            <card shadow type="secondary" class="m--4">
              <template>
                <template v-if="selectedCourier.key == 'JNT'">
                  <h6 class="heading-small text-muted mb-4">
                    ประเภทในการส่งพัสดุ
                  </h6>
                  <div class="row mb-4">
                    <div class="col-12">
                      <RadioBox
                        :pickup_type.sync="pickup_type"
                        :data="{
                          courier: courier_allow,
                          shop_id: shop_id,
                        }"></RadioBox>
                    </div>
                  </div>
                </template>
                <template v-if="checkDropoffVRich()">
                  <SearchTracking
                    :isLoading="isLoadingVRich"
                    isPlaceholder="QFX900100000014"
                    :isError="vRich"
                    :isTracking="dropoffVRich"
                    @checkTracking="checkTrackingVRich()" />
                </template>
                <template v-if="checkDropoffEasyShip()">
                  <SearchTracking
                    :isLoading="isLoadingEasyShip"
                    isPlaceholder="KEX1000037945X"
                    :isError="easyShip"
                    :isTracking="dropoffEasyShip"
                    @checkTracking="checkTrackingEasyShip()" />
                </template>
                <template v-if="checkDropoffQuick()">
                  <SearchTracking
                    :isLoading="isLoadingQuick"
                    isPlaceholder="QFX900100000015"
                    :isError="quick"
                    :isTracking="dropoffQuick"
                    @checkTracking="checkTrackingQuick()" />
                </template>

                <template v-if="!addMoreOrder.isActive">
                  <template v-if="!checkDropoffVRich() && !checkDropoffQuick()">
                    <h6 class="heading-small text-muted mb-2">ต้นทาง</h6>
                    <div
                      class="d-flex justify-content-between align-items-center mb-4">
                      <b-form-checkbox
                        :disabled="
                          !['FLE', 'FLEWP'].includes(selectedCourier.key)
                        "
                        size="lg"
                        v-model="from.source"
                        value="1"
                        unchecked-value="0">
                        <span>ใช้ต้นทางนี้เป็นที่อยู่ในการเข้ารับพัสดุ</span>
                      </b-form-checkbox>
                      <div class="switch-pos">
                        <!-- <div class="form-group"> -->
                        <div class="d-flex align-items-center">
                          <span>ที่อยู่ตามบัตรประชาชน</span>
                          <b-form-checkbox
                            switch
                            size="lg"
                            v-model="isToggle"
                            @input="sameSender"></b-form-checkbox>
                          <span>ที่อยู่ร้าน</span>
                        </div>
                        <!-- </div> -->
                      </div>
                    </div>
                  </template>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label floater
                          ><small class="text-danger">*</small>
                          ชื่อ-นามสกุล</label
                        >
                        <input
                          :disabled="
                            checkDropoffVRich() ||
                            checkDropoffEasyShip() ||
                            checkDisableInputDropoff()
                          "
                          type="text"
                          placeholder
                          class="form-control"
                          v-model="from.name"
                          :class="{
                            'is-invalid':
                              submitAddShipping && $v.from.name.$error,
                          }" />
                        <div
                          v-if="submitAddShipping && !$v.from.name.required"
                          class="invalid-feedback">
                          กรุณากรอกชื่อ-นามสกุล
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label floater
                          ><small class="text-danger">*</small>
                          หมายเลขโทรศัพท์</label
                        >

                        <AutocompletesOrigin
                          :disableInput="
                            checkDropoffVRich() ||
                            checkDropoffEasyShip() ||
                            checkDisableInputDropoff()
                          "
                          ref="fromTel"
                          :endpoint="'/origin/${param}/details'"
                          :data="from.tel"
                          @select:item="onSubmitOriginAutocomp"
                          @input="from.tel = $event.target.value"
                          :class="{
                            'is-invalid':
                              submitAddShipping && $v.from.tel.$error,
                          }">
                          <template slot="custom-items" scope="props">
                            <h6>
                              ชื่อ:{{ props.data.name }} เบอร์:{{
                                props.data.tel
                              }}
                              ที่อยู่:{{ props.data.address }} ตำบล:{{
                                props.data.district
                              }}
                              อำเภอ:{{ props.data.state }} จังหวัด:{{
                                props.data.province
                              }}
                              รหัสปณ.:{{ props.data.postcode }}
                            </h6>
                          </template>
                        </AutocompletesOrigin>
                        <div
                          v-if="submitAddShipping && !$v.from.tel.required"
                          class="invalid-feedback d-block">
                          กรุณากรอกหมายเลขโทรศัพท์
                        </div>
                        <div
                          class="error invalid-feedback d-block"
                          v-if="submitAddShipping && !$v.from.tel.minLength">
                          กรุณากรอก"หมายเลขโทรศัพท์"อย่างน้อย
                          {{ $v.from.tel.$params.minLength.min }} หลัก
                        </div>
                        <div
                          class="error invalid-feedback d-block"
                          v-if="submitAddShipping && !$v.from.tel.maxLength">
                          กรุณากรอก"หมายเลขโทรศัพท์"ไม่เกิน
                          {{ $v.from.tel.$params.maxLength.max }} หลัก
                        </div>
                        <div
                          class="error invalid-feedback"
                          v-if="submitAddShipping && !$v.from.tel.numeric">
                          กรุณากรอกเฉพาะตัวเลข
                        </div>
                        <div
                          class="error invalid-feedback"
                          v-if="submitAddShipping && $v.from.tel.invalid">
                          กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label floater
                          ><small class="text-danger">*</small> ที่อยู่</label
                        >

                        <input
                          :disabled="
                            checkDropoffVRich() ||
                            checkDropoffEasyShip() ||
                            checkDisableInputDropoff()
                          "
                          type="text"
                          placeholder
                          class="form-control"
                          v-model="from.address"
                          :class="{
                            'is-invalid':
                              submitAddShipping && $v.from.address.$error,
                          }" />

                        <div
                          v-if="submitAddShipping && !$v.from.address.required"
                          class="invalid-feedback">
                          กรุณากรอกที่อยู่
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-12 col-md-6 col-lg-6"
                      v-if="checkThemeQuick()">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> รหัสไปรษณีย์
                        </label>
                        <AutocompletesAddress
                          :disableInput="
                            checkDropoffVRich() ||
                            checkDropoffEasyShip() ||
                            checkDisableInputDropoff()
                          "
                          :queryInput="from.postcode"
                          :adsTypes="'postcode'"
                          :class="{
                            'is-invalid':
                              (submitAddShipping && $v.from.postcode.$error) ||
                              validateAddress.from.postcode.status,
                          }"
                          @input="from.postcode = $event.target.value"
                          @select:item="onSubmitAddress($event, 'from')">
                        </AutocompletesAddress>
                        <div
                          v-if="validateAddress.from.postcode.status"
                          class="invalid-th-address">
                          {{ validateAddress.from.postcode.msg }}
                        </div>
                        <div
                          v-if="submitAddShipping && !$v.from.postcode.required"
                          class="invalid-th-address">
                          กรุณากรอกรหัสไปรษณีย์
                        </div>
                        <div
                          class="error invalid-th-address"
                          v-if="
                            submitAddShipping && !$v.from.postcode.minLength
                          ">
                          กรุณากรอก"รหัสไปรษณีย์"
                          {{ $v.from.postcode.$params.minLength.min }} หลัก
                        </div>
                        <div
                          class="error invalid-th-address"
                          v-if="
                            submitAddShipping && !$v.from.postcode.maxLength
                          ">
                          กรุณากรอก"รหัสไปรษณีย์"
                          {{ $v.from.postcode.$params.maxLength.max }} หลัก
                        </div>
                        <div
                          class="error invalid-th-address"
                          v-if="submitAddShipping && !$v.from.postcode.numeric">
                          กรุณากรอกเฉพาะตัวเลข
                        </div>
                      </div>
                      <!-- รหัสไปรษณีย์ -->
                    </div>
                    <div
                      :class="[
                        'col-12 col-md-6',
                        checkThemeQuick() ? 'col-lg-4' : 'col-lg-6',
                      ]">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> ตำบล/แขวง
                        </label>
                        <AutocompletesAddress
                          :disableInput="
                            checkDropoffVRich() ||
                            checkDropoffEasyShip() ||
                            checkDisableInputDropoff()
                          "
                          :queryInput="from.state"
                          :adsTypes="'sub-district'"
                          :class="{
                            'is-invalid':
                              (submitAddShipping && $v.from.state.$error) ||
                              validateAddress.from.state.status,
                          }"
                          @input="from.state = $event.target.value"
                          @select:item="onSubmitAddress($event, 'from')">
                        </AutocompletesAddress>

                        <div
                          v-if="validateAddress.from.state.status"
                          class="invalid-th-address">
                          {{ validateAddress.from.state.msg }}
                        </div>
                        <div
                          v-if="submitAddShipping && !$v.from.state.required"
                          class="invalid-th-address">
                          กรุณากรอกตำบล/แขวง
                        </div>
                      </div>
                      <!-- ตำบล/แขวง -->
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> อำเภอ/เขต
                        </label>
                        <AutocompletesAddress
                          :disableInput="
                            checkDropoffVRich() ||
                            checkDropoffEasyShip() ||
                            checkDisableInputDropoff()
                          "
                          :queryInput="from.district"
                          :adsTypes="'district'"
                          :class="{
                            'is-invalid':
                              (submitAddShipping && $v.from.district.$error) ||
                              validateAddress.from.district.status,
                          }"
                          @input="from.district = $event.target.value"
                          @select:item="onSubmitAddress($event, 'from')">
                        </AutocompletesAddress>

                        <div
                          v-if="validateAddress.from.district.status"
                          class="invalid-th-address">
                          {{ validateAddress.from.district.msg }}
                        </div>
                        <div
                          v-if="submitAddShipping && !$v.from.district.required"
                          class="invalid-th-address">
                          กรุณากรอกอำเภอ/เขต
                        </div>
                      </div>
                      <!-- อำเภอ/เขต -->
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> จังหวัด
                        </label>
                        <AutocompletesAddress
                          :disableInput="
                            checkDropoffVRich() ||
                            checkDropoffEasyShip() ||
                            checkDisableInputDropoff()
                          "
                          :queryInput="from.province"
                          :adsTypes="'province'"
                          :class="{
                            'is-invalid':
                              (submitAddShipping && $v.from.province.$error) ||
                              validateAddress.from.province.status,
                          }"
                          @input="from.province = $event.target.value"
                          @select:item="onSubmitAddress($event, 'from')">
                        </AutocompletesAddress>
                        <div
                          v-if="validateAddress.from.province.status"
                          class="invalid-th-address">
                          {{ validateAddress.from.province.msg }}
                        </div>
                        <div
                          v-if="submitAddShipping && !$v.from.province.required"
                          class="invalid-th-address">
                          กรุณากรอกจังหวัด
                        </div>
                      </div>
                      <!-- จังหวัด -->
                    </div>
                    <div
                      class="col-lg-4 col-12 col-md-6"
                      v-if="!checkThemeQuick()">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> รหัสไปรษณีย์
                        </label>
                        <AutocompletesAddress
                          :disableInput="checkDropoffEasyShip()"
                          :queryInput="from.postcode"
                          :adsTypes="'postcode'"
                          :class="{
                            'is-invalid':
                              (submitAddShipping && $v.from.postcode.$error) ||
                              validateAddress.from.postcode.status,
                          }"
                          @input="from.postcode = $event.target.value"
                          @select:item="onSubmitAddress($event, 'from')">
                        </AutocompletesAddress>
                        <div
                          v-if="validateAddress.from.postcode.status"
                          class="invalid-th-address">
                          {{ validateAddress.from.postcode.msg }}
                        </div>
                        <div
                          v-if="submitAddShipping && !$v.from.postcode.required"
                          class="invalid-th-address">
                          กรุณากรอกรหัสไปรษณีย์
                        </div>
                        <div
                          class="error invalid-th-address"
                          v-if="
                            submitAddShipping && !$v.from.postcode.minLength
                          ">
                          กรุณากรอก"รหัสไปรษณีย์"
                          {{ $v.from.postcode.$params.minLength.min }} หลัก
                        </div>
                        <div
                          class="error invalid-th-address"
                          v-if="
                            submitAddShipping && !$v.from.postcode.maxLength
                          ">
                          กรุณากรอก"รหัสไปรษณีย์"
                          {{ $v.from.postcode.$params.maxLength.max }} หลัก
                        </div>
                        <div
                          class="error invalid-th-address"
                          v-if="submitAddShipping && !$v.from.postcode.numeric">
                          กรุณากรอกเฉพาะตัวเลข
                        </div>
                      </div>
                      <!-- รหัสไปรษณีย์ -->
                    </div>
                  </div>
                  <hr class="my-1" />
                </template>
                <!-- Address -->
                <div class="d-flex justify-content-between mb-2">
                  <h6 class="heading-small text-muted">ปลายทาง</h6>
                  <div class="row mr-1">
                    <CreateOrderByExcel
                      v-if="!checkDropoffVRich() && !checkDropoffEasyShip()"
                      :courierKey="selectedCourier.key"
                      @click.native="checkErrorCreateOrderByExcel = true"
                      @onSuccess="createOrderByExcel"
                      @onError="checkErrorCreateOrderByExcel = $event" />
                  </div>
                </div>
                <b-alert
                  :show="checkErrorCreateOrderByExcel.length > 0"
                  variant="yellow-light"
                  class="p-0">
                  <div class="row">
                    <div class="col-1 d-flex align-items-center m-1">
                      <i
                        class="fas fa-exclamation-circle text-yellow display-3"></i>
                    </div>
                    <div class="col-10">
                      <div
                        v-for="(error, i) in checkErrorCreateOrderByExcel"
                        :key="i">
                        <h5>{{ error.header }}</h5>
                        <h6>{{ error.body }}</h6>
                      </div>
                    </div>
                  </div>
                </b-alert>
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label floater
                        ><small class="text-danger">*</small>
                        ชื่อ-นามสกุล</label
                      >
                      <div
                        class="test-error"
                        :class="{
                          'is-invalid': submitAddShipping && $v.to.name.$error,
                        }">
                        <autocomplete
                          :disabled="
                            checkDropoffVRich() ||
                            checkDropoffEasyShip() ||
                            checkDisableInputDropoff()
                          "
                          :search="searchRecipientDetails"
                          :get-result-value="getValueRecipientDetails"
                          @submit="onSubmitRecipient"
                          v-on:input="to.name = $event.target.value"
                          :value="to.name"
                          :class="[
                            {
                              'is-invalid':
                                submitAddShipping && $v.to.name.$error,
                            },
                            {
                              'disabled-autocomplete':
                                checkDropoffVRich() ||
                                checkDropoffEasyShip() ||
                                checkDisableInputDropoff(),
                            },
                          ]">
                          <template v-slot:result="{ result, props }">
                            <li v-bind="props">
                              <h6>
                                ชื่อ:{{ result.name }} เบอร์:{{
                                  result.tel
                                }}
                                ที่อยู่:{{ result.address }} ตำบล:{{
                                  result.district
                                }}
                                อำเภอ:{{ result.state }} จังหวัด:{{
                                  result.province
                                }}
                                รหัสปณ.:{{ result.postcode }}
                              </h6>
                            </li>
                          </template>
                        </autocomplete>

                        <div
                          v-if="submitAddShipping && !$v.to.name.required"
                          class="invalid-feedback">
                          กรุณากรอกชื่อ-นามสกุล
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label floater
                        ><small class="text-danger">*</small>
                        หมายเลขโทรศัพท์</label
                      >
                      <div
                        class="test-error"
                        :class="{
                          'is-invalid': submitAddShipping && $v.to.tel.$error,
                        }">
                        <autocomplete
                          :disabled="
                            checkDropoffVRich() ||
                            checkDropoffEasyShip() ||
                            checkDisableInputDropoff()
                          "
                          :search="searchRecipientDetails"
                          :get-result-value="getValueRecipientDetails"
                          @submit="onSubmitRecipient"
                          v-on:input="to.tel = $event.target.value"
                          :value="to.tel"
                          @blur="focusOutRecipientDetails"
                          :class="[
                            {
                              'is-invalid':
                                submitAddShipping && $v.to.tel.$error,
                            },
                            {
                              'disabled-autocomplete':
                                checkDropoffVRich() ||
                                checkDropoffEasyShip() ||
                                checkDisableInputDropoff(),
                            },
                          ]">
                          <template v-slot:result="{ result, props }">
                            <li v-bind="props">
                              <h6>
                                ชื่อ:{{ result.name }} เบอร์:{{
                                  result.tel
                                }}
                                ที่อยู่:{{ result.address }} ตำบล:{{
                                  result.district
                                }}
                                อำเภอ:{{ result.state }} จังหวัด:{{
                                  result.province
                                }}
                                รหัสปณ.:{{ result.postcode }}
                              </h6>
                            </li>
                          </template>
                        </autocomplete>
                        <div
                          v-if="submitAddShipping && !$v.to.tel.required"
                          class="invalid-feedback">
                          กรุณากรอกหมายเลขโทรศัพท์
                        </div>
                        <div
                          class="error invalid-feedback"
                          v-if="submitAddShipping && $v.to.tel.minLength">
                          กรุณากรอก"หมายเลขโทรศัพท์"อย่างน้อย
                          {{ $v.to.tel.$params.minLength.min }} หลัก
                        </div>
                        <div
                          class="error invalid-feedback"
                          v-if="submitAddShipping && $v.to.tel.maxLength">
                          กรุณากรอก"หมายเลขโทรศัพท์"ไม่เกิน
                          {{ $v.to.tel.$params.maxLength.max }} หลัก
                        </div>
                        <!-- <div
                          class="error invalid-feedback"
                          v-if="submitAddShipping && !$v.to.tel.numeric"
                        >กรุณากรอกเฉพาะตัวเลข</div> -->
                        <div
                          class="invalid-feedback"
                          v-if="submitAddShipping && $v.to.tel.$invalid">
                          กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label floater
                        ><small class="text-danger">*</small> ที่อยู่</label
                      >

                      <input
                        :disabled="
                          checkDropoffVRich() ||
                          checkDropoffEasyShip() ||
                          checkDisableInputDropoff()
                        "
                        type="text"
                        placeholder
                        class="form-control"
                        v-model="to.address"
                        :class="{
                          'is-invalid':
                            submitAddShipping && $v.to.address.$error,
                        }" />

                      <div
                        v-if="submitAddShipping && !$v.to.address.required"
                        class="invalid-feedback">
                        กรุณากรอกที่อยู่
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-12 col-md-6 col-lg-6"
                    v-if="checkThemeQuick()">
                    <div class="form-group">
                      <label floater>
                        <small class="text-danger">*</small> รหัสไปรษณีย์
                      </label>
                      <AutocompletesAddress
                        :disableInput="
                          checkDropoffVRich() ||
                          checkDropoffEasyShip() ||
                          checkDisableInputDropoff()
                        "
                        :queryInput="to.postcode"
                        :adsTypes="'postcode'"
                        :class="{
                          'is-invalid':
                            (submitAddShipping && $v.to.postcode.$error) ||
                            validateAddress.to.postcode.status,
                        }"
                        @input="to.postcode = $event.target.value"
                        @select:item="onSubmitAddress($event, 'to')"
                        maxlength="5">
                      </AutocompletesAddress>
                      <div
                        v-if="submitAddShipping && !$v.to.postcode.required"
                        class="invalid-th-address">
                        กรุณากรอกรหัสไปรษณีย์
                      </div>
                      <div
                        v-if="validateAddress.to.postcode.status"
                        class="invalid-th-address">
                        {{ validateAddress.to.postcode.msg }}
                      </div>
                      <div
                        class="error invalid-th-address"
                        v-if="submitAddShipping && !$v.to.postcode.minLength">
                        กรุณากรอก"รหัสไปรษณีย์"
                        {{ $v.to.postcode.$params.minLength.min }} หลัก
                      </div>
                      <div
                        class="error invalid-th-address"
                        v-if="submitAddShipping && !$v.to.postcode.maxLength">
                        กรุณากรอก"รหัสไปรษณีย์"
                        {{ $v.to.postcode.$params.maxLength.max }} หลัก
                      </div>
                      <div
                        class="error invalid-th-address"
                        v-if="submitAddShipping && !$v.to.postcode.numeric">
                        กรุณากรอกเฉพาะตัวเลข
                      </div>
                    </div>
                    <!-- รหัสไปรษณีย์ -->
                  </div>
                  <div
                    :class="[
                      'col-12 col-md-6',
                      checkThemeQuick() ? 'col-lg-4' : 'col-lg-6',
                    ]">
                    <div class="form-group">
                      <label floater>
                        <small class="text-danger">*</small> ตำบล/แขวง
                      </label>
                      <AutocompletesAddress
                        :disableInput="
                          checkDropoffVRich() ||
                          checkDropoffEasyShip() ||
                          checkDisableInputDropoff()
                        "
                        :queryInput="to.state"
                        :adsTypes="'sub-district'"
                        :class="{
                          'is-invalid':
                            (submitAddShipping && $v.to.state.$error) ||
                            validateAddress.to.state.status,
                        }"
                        @input="to.state = $event.target.value"
                        @select:item="onSubmitAddress($event, 'to')">
                      </AutocompletesAddress>
                      <div
                        v-if="validateAddress.to.state.status"
                        class="invalid-th-address">
                        {{ validateAddress.to.state.msg }}
                      </div>
                      <div
                        v-if="submitAddShipping && !$v.to.state.required"
                        class="invalid-th-address">
                        กรุณากรอกตำบล/แขวง
                      </div>
                    </div>
                    <!-- ตำบล/แขวง -->
                  </div>
                  <div class="col-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label floater>
                        <small class="text-danger">*</small> อำเภอ/เขต
                      </label>
                      <AutocompletesAddress
                        :disableInput="
                          checkDropoffVRich() ||
                          checkDropoffEasyShip() ||
                          checkDisableInputDropoff()
                        "
                        :queryInput="to.district"
                        :adsTypes="'district'"
                        :class="{
                          'is-invalid':
                            (submitAddShipping && $v.to.district.$error) ||
                            validateAddress.to.district.status,
                        }"
                        @input="to.district = $event.target.value"
                        @select:item="onSubmitAddress($event, 'to')">
                      </AutocompletesAddress>
                      <div
                        v-if="submitAddShipping && !$v.to.district.required"
                        class="invalid-th-address">
                        กรุณากรอกอำเภอ/เขต
                      </div>
                      <div
                        v-if="validateAddress.to.district.status"
                        class="invalid-th-address">
                        {{ validateAddress.to.district.msg }}
                      </div>
                    </div>
                    <!-- อำเภอ/เขต -->
                  </div>
                  <div class="col-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label floater>
                        <small class="text-danger">*</small> จังหวัด
                      </label>
                      <AutocompletesAddress
                        :disableInput="
                          checkDropoffVRich() ||
                          checkDropoffEasyShip() ||
                          checkDisableInputDropoff()
                        "
                        :queryInput="to.province"
                        :adsTypes="'province'"
                        :class="{
                          'is-invalid':
                            (submitAddShipping && $v.to.province.$error) ||
                            validateAddress.to.province.status,
                        }"
                        @input="to.province = $event.target.value"
                        @select:item="onSubmitAddress($event, 'to')">
                      </AutocompletesAddress>
                      <div
                        v-if="submitAddShipping && !$v.to.province.required"
                        class="invalid-th-address">
                        กรุณากรอกจังหวัด
                      </div>
                      <div
                        v-if="validateAddress.to.province.status"
                        class="invalid-th-address">
                        {{ validateAddress.to.province.msg }}
                      </div>
                    </div>
                    <!-- จังหวัด -->
                  </div>

                  <div class="col-lg-4" v-if="!checkThemeQuick()">
                    <div class="form-group">
                      <label floater>
                        <small class="text-danger">*</small> รหัสไปรษณีย์
                      </label>
                      <AutocompletesAddress
                        :disableInput="checkDropoffEasyShip()"
                        :queryInput="to.postcode"
                        :adsTypes="'postcode'"
                        :class="{
                          'is-invalid':
                            (submitAddShipping && $v.to.postcode.$error) ||
                            validateAddress.to.postcode.status,
                        }"
                        @input="to.postcode = $event.target.value"
                        @select:item="onSubmitAddress($event, 'to')"
                        maxlength="5">
                      </AutocompletesAddress>
                      <div
                        v-if="submitAddShipping && !$v.to.postcode.required"
                        class="invalid-th-address">
                        กรุณากรอกรหัสไปรษณีย์
                      </div>
                      <div
                        v-if="validateAddress.to.postcode.status"
                        class="invalid-th-address">
                        {{ validateAddress.to.postcode.msg }}
                      </div>
                      <div
                        class="error invalid-th-address"
                        v-if="submitAddShipping && !$v.to.postcode.minLength">
                        กรุณากรอก"รหัสไปรษณีย์"
                        {{ $v.to.postcode.$params.minLength.min }} หลัก
                      </div>
                      <div
                        class="error invalid-th-address"
                        v-if="submitAddShipping && !$v.to.postcode.maxLength">
                        กรุณากรอก"รหัสไปรษณีย์"
                        {{ $v.to.postcode.$params.maxLength.max }} หลัก
                      </div>
                      <div
                        class="error invalid-th-address"
                        v-if="submitAddShipping && !$v.to.postcode.numeric">
                        กรุณากรอกเฉพาะตัวเลข
                      </div>
                    </div>
                    <!-- รหัสไปรษณีย์ -->
                  </div>
                </div>
                <hr class="my-4" />
                <!-- Description -->
                <h6 class="heading-small text-muted">รายละเอียดเพิ่มเติม</h6>
                <!-- AutoBox -->
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label floater
                        ><small class="text-danger">*</small>
                        น้ำหนัก
                        <small>{{
                          checkUntiKG() ? "( กิโลกรัม )" : "( กรัม )"
                        }}</small>
                      </label>
                      <input
                        type="number"
                        placeholder="น้ำหนัก"
                        class="form-control"
                        v-model="$data[checkUntiKG() ? 'weightKG' : 'weight']"
                        v-on:keyup="itemPreRate()"
                        :onkeydown="
                          checkUntiKG()
                            ? 'return event.keyCode !== 69 && event.keyCode !== 189'
                            : 'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'
                        "
                        :class="{
                          'is-invalid':
                            (submitAddShipping &&
                              (checkUntiKG()
                                ? $v.weightKG.$error
                                : $v.weight.$error)) ||
                            rateError ||
                            errorWeight ||
                            !validate.modalParcel.checkDimension.status,
                        }"
                        :disabled="lockWeight" />
                      <div
                        v-if="
                          submitAddShipping &&
                          (checkUntiKG()
                            ? !$v.weightKG.required
                            : !$v.weight.required)
                        "
                        class="invalid-feedback">
                        กรุณากรอกน้ำหนัก
                      </div>

                      <small
                        v-if="
                          rateError &&
                          selectedCourier.key == 'SCG' &&
                          ['PM', 'PL', 'Envelop'].includes(keyBox)
                        "
                        class="text-danger">
                        ไม่สามารถสร้างรายการได้ เนื่องจากขนาดพัสดุ
                        Envelop/Polymer Bag ของ SCG รองรับพัสดุได้สูงสุด
                        {{ checkUntiKG() ? "1 กิโลกรัม" : "1,000 กรัม" }}
                        กรุณาเปลี่ยนพัสดุลงกล่อง และเลือกขนาดพัสดุใหม่
                      </small>
                      <small v-else-if="rateError" class="text-danger">
                        ไม่สามารถสร้างรายการได้ เนื่องจากเหตุ
                        <ul>
                          <li>ไม่พบเรทราคา</li>
                          <li>น้ำหนัก/ขนาดพัสดุ เกินที่ขนส่งกำหนด</li>
                          <li>ขนส่งไม่เปิดให้บริการในพื้นที่ต้นทาง/ปลายทาง</li>
                        </ul>
                      </small>
                      <small v-if="errorWeight" class="text-danger"
                        >กรุณาใส่น้ำหนักมากกว่า 0
                      </small>
                      <small
                        v-if="!validate.modalParcel.checkDimension.status"
                        class="text-danger"
                        >{{ validate.modalParcel.checkDimension.msg }}
                      </small>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="row">
                      <AutoBox
                        :size="size"
                        :weight.sync="weight"
                        :weightKG.sync="weightKG"
                        :width.sync="width"
                        :length.sync="length"
                        :height.sync="height"
                        :keyBox.sync="keyBox"
                        :courier_key="selectedCourier.key"
                        @itemPreRate="itemPreRate()" />
                      <!-- weightKG เฉพาะขนส่ง KERRY -->
                    </div>
                  </div>
                  <div
                    class="col-lg-6"
                    v-if="issetParcelInsurance && !checkDropoffVRich()">
                    <label for="input-live">เลือกประเภทสินค้า</label>
                    <InputParcelType
                      ref="inputParcelType"
                      :data="insurance"
                      :error="checkErrorSeletedParcelInsurance" />
                  </div>
                  <!-- <div
                    class="col-lg-6"
                    v-if="
                      cod_details.isCod &&
                      (checkDropoffVRich() || checkDropoffQuick())
                    ">
                    <div class="form-group">
                      <label floater
                        ><small class="text-danger">*</small> ยอดเก็บเงินปลายทาง
                        <small>( บาท )</small>
                      </label>
                      <input
                        disabled
                        type="number"
                        placeholder="จำนวนเงิน"
                        class="form-control"
                        v-on:keyup="checkCodAmount()"
                        v-model="codAmount"
                        :class="{
                          'is-invalid':
                            (submitAddShipping && $v.codAmount.$error) ||
                            errorCodAmount,
                        }" />
                      <div
                        v-if="submitAddShipping && !$v.codAmount.required"
                        class="invalid-feedback">
                        กรุณากรอกจำนวนเงิน
                      </div>
                      <small v-if="errorCodAmount" class="text-danger"
                        >ไม่สามารถสร้างรายการได้
                        เนื่องจากยอดเรียกเก็บปลายทางขั้นต่ำ
                        {{ codCondition.min | numFormat("0,0") }} บาท และไม่เกิน
                        {{ codCondition.max | numFormat("0,0") }} บาทค่ะ</small
                      >
                    </div>
                  </div> -->
                  <div class="col-lg-6">
                    <div role="group">
                      <label for="input-live">ขนาดพัสดุ ( เซนติเมตร )</label>
                      <div class="row">
                        <div class="col boxs">
                          <input
                            type="number"
                            min="1"
                            placeholder="กว้าง"
                            class="form-control"
                            v-model="width"
                            :disabled="lockDimension"
                            v-on:keyup="itemPreRate()"
                            v-on:blur="itemPreRate()"
                            :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                            :class="{
                              'is-invalid':
                                validate.modalParcel.dimension.width.status ==
                                false,
                            }" />
                          <small
                            v-if="
                              validate.modalParcel.dimension.width.status ==
                              false
                            "
                            class="text-danger"
                            >{{
                              validate.modalParcel.dimension.width.msg
                            }}</small
                          >
                        </div>
                        <div class="col boxs">
                          <input
                            type="number"
                            min="1"
                            placeholder="ยาว"
                            class="form-control"
                            v-model="length"
                            :disabled="lockDimension"
                            v-on:keyup="itemPreRate()"
                            v-on:blur="itemPreRate()"
                            :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                            :class="{
                              'is-invalid':
                                validate.modalParcel.dimension.length.status ==
                                false,
                            }" />
                          <small
                            v-if="
                              validate.modalParcel.dimension.length.status ==
                              false
                            "
                            class="text-danger"
                            >{{
                              validate.modalParcel.dimension.length.msg
                            }}</small
                          >
                        </div>
                        <div class="col">
                          <input
                            type="number"
                            min="1"
                            placeholder="สูง"
                            class="form-control"
                            :disabled="lockDimension"
                            v-model="height"
                            v-on:keyup="itemPreRate()"
                            v-on:blur="itemPreRate()"
                            :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                            :class="{
                              'is-invalid':
                                validate.modalParcel.dimension.height.status ==
                                false,
                            }" />
                          <small
                            v-if="
                              validate.modalParcel.dimension.height.status ==
                              false
                            "
                            class="text-danger"
                            >{{
                              validate.modalParcel.dimension.height.msg
                            }}</small
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label floater
                        >ยอดเก็บเงินปลายทาง
                        <small>( บาท )</small>
                      </label>
                      <input
                        type="number"
                        :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                        placeholder="จำนวนเงิน"
                        class="form-control"
                        v-model="codAmount" />
                    </div>
                    <!-- code mix -->
                  </div>
                  <!-- modal barcode -->
                  <div
                    class="col-lg-6"
                    v-if="this.selectedCourier.shippop == 0">
                    <div class="form-group mb-0">
                      <label>เลข Tracking</label>
                      <input
                        type="text"
                        v-model="tracking"
                        placeholder="รหัส Barcode"
                        @change="checkBarcode"
                        class="form-control"
                        :class="{
                          'is-invalid': errorBarcode || barcodeError,
                        }" />
                      <small v-if="errorBarcode" class="text-danger"
                        >กรุณากรอกรหัส Barcode ให้ถูกต้อง</small
                      >
                      <small v-if="barcodeError" class="text-danger"
                        >รหัส Barcode ซ้ำ กรุณาใช้รหัส Barcode อื่น</small
                      >
                      <small v-if="barcodeOk" class="text-success"
                        >สามารถใช้รหัส Barcode นี้ได้</small
                      >
                    </div>
                  </div>
                </div>
                <div
                  class="row mt-4"
                  v-if="issetParcelInsurance && !checkDropoffVRich()">
                  <div class="col-lg-6">
                    <ParcelInsurance
                      ref="parcelInsurance"
                      :data="insurance"
                      :clear="clearInputInsurance"
                      :error="checkErrorParcelInsurance" />
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group mb-0">
                      <label>ราคา</label>
                      <div class="display-3 text-right">
                        {{ showPreRate | numFormat("0,0.00") }}
                        <small>บาท</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row d-flex justify-content-end" v-else>
                  <div class="col-lg-6">
                    <div class="form-group mb-0">
                      <label>ราคา</label>
                      <div class="display-3 text-right">
                        {{ prerate | numFormat("0,0.00") }}
                        <small>บาท</small>
                      </div>
                    </div>
                  </div>
                </div>
                <b-alert
                  :show="errorAlertParcel.status"
                  variant="yellow-light"
                  class="text-center">
                  <h4 v-html="errorAlertParcel.msg"></h4>
                </b-alert>
                <b-alert
                  :show="errorCreateOrderByOne.status"
                  variant="yellow-light"
                  class="text-center">
                  <h4 class="text-red">{{ errorCreateOrderByOne.msg }}</h4>
                </b-alert>
                <b-alert
                  :show="
                    (checkDropoffVRich() ||
                      checkDropoffEasyShip() ||
                      checkDropoffQuick()) &&
                    codAmount > 0 &&
                    sender.mem_id == 0
                  "
                  variant="yellow-light"
                  class="text-center">
                  <h4 class="text-danger">
                    ลูกค้ายังไม่ได้สมัคร COD กรุณาสมัครใช้งานก่อน
                    <span
                      class="text-link cursor-pointer"
                      @click="openRegisterCOD()"
                      ><u>ที่นี่ </u><i class="fas fa-chevron-right"></i
                    ></span>
                  </h4>
                  <small>
                    หากลูกค้าสมัคร COD แล้ว กรุณากดปุ่มเพื่อตรวจสอบสมาชิก COD
                    อีกครั้ง
                    <button
                      class="btn btn-info btn-sm mx-1"
                      @click="checkVerifyMemberCod()">
                      <i
                        :class="
                          isLoadingCheckCod
                            ? 'fas fa-circle-notch fa-spin'
                            : 'fas fa-sync-alt'
                        "></i>
                    </button>
                  </small>
                </b-alert>
                <div class="mt-4 w-100 text-right">
                  <div class="row justify-content-end">
                    <div class="col-3">
                      <b-button
                        block
                        variant="secondary"
                        @click="printLabelByOne()">
                        พิมพ์ใบปะหน้า
                      </b-button>
                    </div>
                    <div class="col-3">
                      <b-button
                        block
                        variant="secondary"
                        @click="
                          closeParcel(),
                            clearInputValidateDimension(),
                            clearInputInsurance()
                        ">
                        ยกเลิก
                      </b-button>
                    </div>
                    <div class="col-6">
                      <!-- nuttakorn -->
                      <b-button
                        block
                        type="submit"
                        variant="success"
                        @click="validateShip"
                        :disabled="
                          isLoadingShip ||
                          rateError ||
                          errorAlertParcel.disableButton ||
                          ((checkDropoffVRich() ||
                            checkDropoffEasyShip() ||
                            checkDropoffQuick()) &&
                            codAmount > 0 &&
                            sender.mem_id == 0)
                        ">
                        <i
                          class="fas fa-circle-notch fa-spin"
                          v-if="isLoadingShip"></i>
                        {{
                          checkThemeQuick() &&
                          !editorder &&
                          !checkDropoffVRich() &&
                          !checkDropoffQuick()
                            ? "พิมพ์ใบปะหน้า"
                            : "ยืนยัน"
                        }}
                      </b-button>
                    </div>
                  </div>
                </div>
              </template>
            </card>
          </b-modal>

          <!-- Modal คิดเงิน -->

          <ModalCheckBill
            :checkBill="checkBill"
            :totalCourierPrice="totalCourierPrice"
            :totalPriceOrder="total"
            @confirmCreateOrder="buyTotal" />

          <!-- Modal บัตรประชาชน -->
          <ModalSender
            ref="modalSender"
            :sender="sender"
            :preBarcode="preBarcode"
            :searchSenderDetails="searchSenderDetails"
            :errorBirthday="errorBirthday"
            :errorIdCard="errorIdCard"
            @checkIdNo="checkIdNo"
            @checkIdCard="checkIdCard($event)"
            @onSubmitAddress="onSubmitAddress($event, 'sender')"
            @formatDate="formatDate()"
            @close="close()" />

          <!-- Modal prebarcode -->
          <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            ref="modal-prebarcode"
            @hidden="closeParcel"
            id="modal-prebarcode"
            size="lg"
            hide-footer
            @shown="focusMyElement"
            no-stacking>
            <template slot="modal-title">
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-12 d-flex align-items-center">
                    <h3 class="mb-0">ระบบ prebarcode</h3>
                  </div>
                </div>
              </div>
            </template>
            <card shadow type="secondary" class="m--4">
              <template>
                <h6 class="heading-small text-muted mb-4">ข้อมูลพัสดุ</h6>
                <div>
                  <div class="row">
                    <div
                      class="col-lg-6 d-flex align-items-center justify-content-center">
                      <div class="f">
                        <img
                          v-if="iconUrl.status != false"
                          class="card-img-top pl-3 img-mx-250"
                          :src="iconUrl.url"
                          img-alt="Image" />
                        <h3 v-else>{{ iconUrl.courierName }}</h3>
                        <!-- <div>{{selectedCourier.name}}</div> -->
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <AutoBox
                        :size="size"
                        :width.sync="width"
                        :length.sync="length"
                        :height.sync="height"
                        :keyBox.sync="keyBox"
                        :courier_key="selectedCourier.key"
                        @itemPreRate="itemPreRate()" />
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label
                          ><small class="text-danger">*</small> น้ำหนัก
                          {{ checkUntiKG() ? "(กิโลกรัม)" : "(กรัม)" }}</label
                        >
                        <input
                          ref="focusWeight"
                          type="number"
                          v-model="$data[checkUntiKG() ? 'weightKG' : 'weight']"
                          v-on:keyup="itemPreRate()"
                          :placeholder="
                            checkUntiKG()
                              ? 'น้ำหนัก (กิโลกรัม)'
                              : 'น้ำหนัก (กรัม)'
                          "
                          class="form-control"
                          :class="{
                            'is-invalid':
                              (submitAddPrebarcode &&
                                (checkUntiKG()
                                  ? $v.weightKG.$error
                                  : $v.weight.$error)) ||
                              ratePreError ||
                              errorWeight,
                          }" />
                        <div
                          v-if="
                            submitAddPrebarcode &&
                            (checkUntiKG()
                              ? !$v.weightKG.required
                              : !$v.weight.required)
                          "
                          class="invalid-feedback">
                          กรุณากรอกนำ้หนัก
                          {{ checkUntiKG() ? "(กิโลกรัม)" : "(กรัม)" }}
                        </div>
                        <small v-if="ratePreError" class="text-danger"
                          >ไม่สามารถสร้างรายการได้ เนื่องจากไม่มีเรทราคานี้
                          กรุณากรอกน้ำหนักให้ถูกต้องค่ะ</small
                        >
                        <small v-if="errorWeight" class="text-danger"
                          >กรุณาใส่น้ำหนักมากกว่า 0</small
                        >
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div role="group">
                        <label for="input-live">ขนาดพัสดุ ( เซนติเมตร )</label>
                        <div class="row">
                          <div class="col boxs">
                            <input
                              type="number"
                              min="1"
                              placeholder="กว้าง"
                              class="form-control"
                              v-model="width"
                              :disabled="lockDimension"
                              v-on:keyup="itemPreRate()"
                              :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                              :class="{
                                'is-invalid':
                                  validate.modalParcel.dimension.width.status ==
                                  false,
                              }" />
                            <small
                              v-if="
                                validate.modalParcel.dimension.width.status ==
                                false
                              "
                              class="text-danger"
                              >{{
                                validate.modalParcel.dimension.width.msg
                              }}</small
                            >
                          </div>
                          <div class="col boxs">
                            <input
                              type="number"
                              min="1"
                              placeholder="ยาว"
                              class="form-control"
                              v-model="length"
                              :disabled="lockDimension"
                              v-on:keyup="itemPreRate()"
                              :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                              :class="{
                                'is-invalid':
                                  validate.modalParcel.dimension.length
                                    .status == false,
                              }" />
                            <small
                              v-if="
                                validate.modalParcel.dimension.length.status ==
                                false
                              "
                              class="text-danger"
                              >{{
                                validate.modalParcel.dimension.length.msg
                              }}</small
                            >
                          </div>
                          <div class="col">
                            <input
                              type="number"
                              min="1"
                              placeholder="สูง"
                              class="form-control"
                              :disabled="lockDimension"
                              v-model="height"
                              v-on:keyup="itemPreRate()"
                              :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                              :class="{
                                'is-invalid':
                                  validate.modalParcel.dimension.height
                                    .status == false,
                              }" />
                            <small
                              v-if="
                                validate.modalParcel.dimension.height.status ==
                                false
                              "
                              class="text-danger"
                              >{{
                                validate.modalParcel.dimension.height.msg
                              }}</small
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="form-group mb-0">
                        <label>ราคา</label>
                        <div class="display-3 text-right">
                          {{ showPreRate | numFormat("0,0.00") }}
                          <small>บาท</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="my-4" />
                <h6 class="heading-small text-muted mb-4">ข้อมูลปลายทาง</h6>
                <div>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label
                          ><small class="text-danger">*</small> รหัส
                          Barcode</label
                        >
                        <input
                          type="text"
                          v-model="scanBarcode"
                          placeholder="รหัส Barcode"
                          class="form-control"
                          @change="checkBarcode"
                          :class="{
                            'is-invalid':
                              (submitAddPrebarcode && $v.scanBarcode.$error) ||
                              errorBarcode ||
                              barcodeError,
                          }" />
                        <div
                          v-if="submitAddPrebarcode && !$v.scanBarcode.required"
                          class="invalid-feedback">
                          กรุณากรอกรหัส Barcode
                        </div>
                        <div
                          class="error invalid-feedback"
                          v-if="
                            submitAddPrebarcode && !$v.scanBarcode.minLength
                          ">
                          กรุณากรอก"รหัส Barcode"{{
                            $v.scanBarcode.$params.minLength.min
                          }}
                          หลัก
                        </div>
                        <small v-if="errorBarcode" class="text-danger"
                          >กรุณากรอกรหัส Barcode ให้ถูกต้อง</small
                        >
                        <small v-if="barcodeError" class="text-danger"
                          >รหัส Barcode ซ้ำ กรุณาใช้รหัส Barcode อื่น</small
                        >
                        <small v-if="barcodeOk" class="text-success"
                          >สามารถใช้รหัส Barcode นี้ได้</small
                        >
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label floater
                          ><small class="text-danger">*</small>
                          ชื่อผู้รับ</label
                        >
                        <div
                          class="test-error"
                          :class="{
                            'is-invalid':
                              submitAddPrebarcode && $v.to.name.$error,
                          }">
                          <autocomplete
                            :search="searchRecipientDetails"
                            :get-result-value="getValueRecipientDetails"
                            @submit="onSubmitRecipient"
                            v-on:input="to.name = $event.target.value"
                            ref="toName"
                            :value="to.name"
                            :class="{
                              'is-invalid':
                                submitAddShipping && $v.to.name.$error,
                            }">
                            <template v-slot:result="{ result, props }">
                              <li v-bind="props">
                                <h6>
                                  ชื่อ:{{ result.name }} เบอร์:{{
                                    result.tel
                                  }}
                                  ที่อยู่:{{ result.address }} ตำบล:{{
                                    result.district
                                  }}
                                  อำเภอ:{{ result.state }} จังหวัด:{{
                                    result.province
                                  }}
                                  รหัสปณ.:{{ result.postcode }}
                                </h6>
                              </li>
                            </template>
                          </autocomplete>

                          <div
                            v-if="submitAddPrebarcode && !$v.to.name.required"
                            class="invalid-feedback">
                            กรุณากรอกชื่อผู้รับ
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label
                          ><small class="text-danger">*</small> ที่อยู่</label
                        >
                        <input
                          type="text"
                          placeholder="ที่อยู่"
                          class="form-control"
                          v-model="to.address"
                          :class="{
                            'is-invalid':
                              submitAddPrebarcode && $v.to.address.$error,
                          }" />
                        <div
                          v-if="submitAddPrebarcode && !$v.to.address.required"
                          class="invalid-feedback">
                          กรุณากรอกที่อยู่
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-6">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> ตำบล/แขวง
                        </label>
                        <AutocompletesAddress
                          :queryInput="to.state"
                          :adsTypes="'sub-district'"
                          :class="{
                            'is-invalid':
                              submitAddPrebarcode && $v.to.state.$error,
                          }"
                          @input="to.state = $event.target.value"
                          @select:item="onSubmitAddress($event, 'to')">
                        </AutocompletesAddress>
                        <div
                          v-if="submitAddPrebarcode && !$v.to.state.required"
                          class="invalid-th-address">
                          กรุณากรอกตำบล/แขวง
                        </div>
                      </div>
                      <!-- ตำบล/แขวง -->
                    </div>
                    <div class="col-12 col-md-6 col-lg-6">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> อำเภอ/เขต
                        </label>
                        <AutocompletesAddress
                          :queryInput="to.district"
                          :adsTypes="'district'"
                          :class="{
                            'is-invalid':
                              submitAddPrebarcode && $v.to.district.$error,
                          }"
                          @input="to.district = $event.target.value"
                          @select:item="onSubmitAddress($event, 'to')">
                        </AutocompletesAddress>
                        <div
                          v-if="submitAddPrebarcode && !$v.to.district.required"
                          class="invalid-th-address">
                          กรุณากรอกอำเภอ/เขต
                        </div>
                      </div>
                      <!-- อำเภอ/เขต -->
                    </div>
                    <div class="col-12 col-md-6 col-lg-6">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> จังหวัด
                        </label>
                        <AutocompletesAddress
                          :queryInput="to.province"
                          :adsTypes="'province'"
                          :class="{
                            'is-invalid':
                              submitAddPrebarcode && $v.to.province.$error,
                          }"
                          @input="to.province = $event.target.value"
                          @select:item="onSubmitAddress($event, 'to')">
                        </AutocompletesAddress>
                        <div
                          v-if="submitAddPrebarcode && !$v.to.province.required"
                          class="invalid-th-address">
                          กรุณากรอกจังหวัด
                        </div>
                      </div>
                      <!-- จังหวัด -->
                    </div>

                    <div class="col-lg-6">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> รหัสไปรษณีย์
                        </label>
                        <AutocompletesAddress
                          :queryInput="to.postcode"
                          :adsTypes="'postcode'"
                          :class="{
                            'is-invalid':
                              submitAddPrebarcode && $v.to.postcode.$error,
                          }"
                          @input="to.postcode = $event.target.value"
                          @select:item="onSubmitAddress($event, 'to')"
                          maxlength="5">
                        </AutocompletesAddress>
                        <div
                          v-if="submitAddPrebarcode && !$v.to.postcode.required"
                          class="invalid-th-address">
                          กรุณากรอกรหัสไปรษณีย์
                        </div>
                        <div
                          class="error invalid-th-address"
                          v-if="
                            submitAddPrebarcode && !$v.to.postcode.minLength
                          ">
                          กรุณากรอก"รหัสไปรษณีย์"
                          {{ $v.to.postcode.$params.minLength.min }} หลัก
                        </div>
                        <div
                          class="error invalid-th-address"
                          v-if="
                            submitAddPrebarcode && !$v.to.postcode.maxLength
                          ">
                          กรุณากรอก"รหัสไปรษณีย์"
                          {{ $v.to.postcode.$params.maxLength.max }} หลัก
                        </div>
                        <div
                          class="error invalid-th-address"
                          v-if="submitAddPrebarcode && !$v.to.postcode.numeric">
                          กรุณากรอกเฉพาะตัวเลข
                        </div>
                      </div>
                      <!-- รหัสไปรษณีย์ -->
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label
                          ><small class="text-danger">*</small>
                          เบอร์ผู้รับ</label
                        >
                        <div
                          class="test-error"
                          :class="{
                            'is-invalid':
                              submitAddPrebarcode && $v.to.tel.$error,
                          }">
                          <autocomplete
                            :search="searchRecipientDetails"
                            :get-result-value="getValueRecipientDetails"
                            @submit="onSubmitRecipient"
                            v-on:input="to.tel = $event.target.value"
                            :value="to.tel"
                            :class="{
                              'is-invalid':
                                submitAddPrebarcode && $v.to.tel.$error,
                            }">
                            <template v-slot:result="{ result, props }">
                              <li v-bind="props">
                                <h6>
                                  ชื่อ:{{ result.name }} เบอร์:{{
                                    result.tel
                                  }}
                                  ที่อยู่:{{ result.address }} ตำบล:{{
                                    result.district
                                  }}
                                  อำเภอ:{{ result.state }} จังหวัด:{{
                                    result.province
                                  }}
                                  รหัสปณ.:{{ result.postcode }}
                                </h6>
                              </li>
                            </template>
                          </autocomplete>

                          <div
                            v-if="submitAddPrebarcode && !$v.to.tel.required"
                            class="invalid-feedback">
                            กรุณากรอกเบอร์ผู้รับ
                          </div>
                          <div
                            class="error invalid-feedback"
                            v-if="submitAddPrebarcode && !$v.to.tel.minLength">
                            กรุณากรอก"หมายเลขโทรศัพท์"อย่างน้อย
                            {{ $v.to.tel.$params.minLength.min }} หลัก
                          </div>
                          <div
                            class="error invalid-feedback"
                            v-if="submitAddPrebarcode && !$v.to.tel.maxLength">
                            กรุณากรอก"หมายเลขโทรศัพท์"ไม่เกิน
                            {{ $v.to.tel.$params.maxLength.max }} หลัก
                          </div>
                          <div
                            class="error invalid-feedback"
                            v-if="submitAddPrebarcode && !$v.to.tel.numeric">
                            กรุณากรอกเฉพาะตัวเลข
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-4 w-100 text-right">
                  <b-button
                    variant="secondary"
                    @click="$bvModal.hide('modal-prebarcode')"
                    :disabled="addMoreOrder.isDisable"
                    >ยกเลิก</b-button
                  >
                  <b-button
                    type="submit"
                    variant="primary"
                    @click="validatePrebarcode"
                    >ยืนยัน</b-button
                  >
                </div>
              </template>
            </card>
          </b-modal>

          <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            v-model="courierTime.show"
            @hidden="closeModalCourierTime"
            body-class="p-0"
            header-class="p-1">
            <template slot="modal-title">
              <div slot="header" class="bg-white border-0 ml-2">
                <div class="row align-items-center"></div>
              </div>
              <div slot="body">
                <div class="col-12 text-center">
                  <h3 class="mb-0">
                    <i class="fas fa-exclamation-circle text-warning fa-lg"></i>
                    <br />
                    โปรโมชั่นสิ้นสุด {{ expired_date }} น.
                    <br />หากกดรับเงินหลังเวลา
                    {{ expired_date }} น.<br />จะไม่สามารถสร้างรายการได้
                    ขอบคุณค่ะ
                  </h3>
                </div>
              </div>
            </template>
            <div class="row">
              <div class="col-lg-12 text-center">
                <div class="w-100 py-2">
                  <b-button
                    variant="warning"
                    class="px-6"
                    @click="closeModalCourierTime">
                    ตกลง
                  </b-button>
                </div>
              </div>
            </div>
          </b-modal>
        </div>
      </slide-y-up-transition>
    </div>
    <footer class="pb-3">
      <div class="container-fluid">
        <div class="row align-items-center justify-content-xl-between">
          <div class="col-xl-6">
            <div class="copyright text-center text-xl-left text-white">
              &copy; {{ year }}
              <a
                href="/"
                class="font-weight-bold ml-1 text-white"
                target="_blank"
                >{{ $THEME.webTitle }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </footer>
    <ModalNotification
      :notiShop="noti"
      @close="noti.type == 'LOCK' ? reset() : ''" />
    <!-- <ModalProductAvoid v-if="!checkThemeQuick()" :productAvoid="productAvoid" @close="closeModalProductAvoid()" /> -->
    <ModalAlertCredit :alertCredit="alertCredit" />
    <ModelAlertOverdueBalance :alertOverdue="alertOverdue" />
    <ModalCourierTeleport :courierTeleport="courierTeleport" />
  </div>
</template>

<script>
import {
  required,
  requiredIf,
  minLength,
  maxLength,
  numeric,
  helpers,
} from "vuelidate/lib/validators";
import PosComponents from "@/components/custom/pos/import";
import AutoBox from "../components/AutoBox";
import AutocompletesAddress from "@/components/Autocomplete/AddressTH/AutocompleteAddressTH";
import ModalNotification from "@/components/custom/ModalNotification";
import RadioBox from "@/components/custom/pos/RadioBox";
import CodCourierList from "@/components/custom/pos/CodCourierList";
import TableAddOrders from "@/components/custom/pos/TableAddOrders";
import InterParcelService from "@/components/custom/pos/modal/InterParcelService";
import ModalService from "@/components/custom/pos/modal/ModalService";
import AutocompletesOrigin from "@/components/Autocomplete/Autocompletes";
import ModalProductAvoid from "@/components/Modals/ModalAvoid";
import ModalCourierTeleport from "@/components/Modals/ModalCourierTeleport";
import ModalInsurance from "@/components/Modals/ModalInsurance";
import ModalAlertRemoteArea from "@/components/custom/pos/modal/ModalAlertRemoteArea";
import NavbarPos from "@/components/custom/pos/NavbarPos";
import InputParcelType from "@/components/custom/pos/InputParcelType";
import ParcelInsurance from "@/components/custom/pos/ParcelInsurance";
import Courier from "@/courier/Courier";
import CardPos from "../components/CardPos";
import CardItems from "../components/CardItem";
import { SlideYUpTransition } from "vue2-transitions";
import { DataStore } from "vue-thailand-address";
import moment from "moment";
import validatePop from "../plugins/validatePop.js";
import validCourier from "../plugins/validCourierFormat.js";
import { log } from "util";
import draggable from "vuedraggable";
import Sortable from "sortablejs";
import { CancelToken } from "axios";
import { maxHeaderSize } from "http";
import courierRules from "@/constants/CourierRules";
import PREBARCODE_PATTERN from "@/constants/PrebarcodePattern";
import { COURIERS_COD } from "@/constants/CourierCOD";
import {
  swapBarcode,
  checkPersonID,
  printReceipt,
} from "@/plugins/posHelper.js";
import {
  getLabelHtml,
  cancelOrderByOne,
  getLabelHtmlByTracking,
  checkMemberCod,
} from "@/axios/pos.js";
import {
  searchSenderDetails,
  searchRecipientDetails,
  focusOutRecipientDetails,
  getValueRecipientDetails,
  searchTrackingDropoff,
} from "@/axios/search.js";
import ModalAlertCredit from "@/components/Modals//ModalAlertCredit";
import ModelAlertOverdueBalance from "@/components/Modals//ModelAlertOverdueBalance";
import ModalShabuEVoucher from "@/components/Modals/ModalShabuEVoucher";
import ModalZendai from "@/components/Modals/ModalZendai";
import { courierDetail as _COURIERS_ } from "@/config/courierCodes";
import { resolve } from "url";
import ModalCheckBill from "@/components/custom/pos/modal/ModalCheckBill";
import ModalSender from "@/components/custom/pos/modal/ModalSender";
import { walletPayment } from "@/axios/walletPayment.js";
import setLocalStorage from "@/constants/LocalStorageManagement";
import SearchTracking from "@/components/custom/pos/SearchTracking";
import configPOPTheme from "@/config/POPTheme";
import KerryDropoff from "@/components/custom/pos/modal/KerryDropoff";
import { deleteShipment, deleteBatch } from "@/axios/kerryDropoff.js";
import { setCookie, getCookie } from "@/helpers/util.js";
import { sound } from "@/plugins/soundEffect.js";
import { label as _LABEL_ } from "@/plugins/label-print.js";

const API_URL = process.env.VUE_APP_API;
const DROPOFF_SP = "dropoffShippop";
const KERRY_DROPOFF = "kerryDropoff";
const INTER_PARCEL = "shippop-inter-parcel";
const ACTION_CREATE_ORDER = {
  index: "index",
  excel: "create_order_by_import_excel",
  modalParcel: "model-parcel",
  modalPrebarcode: "modal-prebarcode",
};
const TYPE_MANUAL = "manual";
const TYPE_EXCEL = "excel";

const groupBy = (array, key) => {
  // Return the end result
  return array.reduce((result, currentValue) => {
    // If an array already present for key, push it to the array. Else create an array and push the object
    (result[currentValue[key]] = result[currentValue[key]] || []).push(
      currentValue
    );
    // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
    return result;
  }, {}); // empty object is the initial value for result object
};
const COURIER = new Courier();

export default {
  name: "pos",
  display: "Transition",
  data() {
    return {
      vRich: {
        errorMsg: "",
      },
      quick: {
        errorMsg: "",
      },
      easyShip: {
        errorMsg: "",
      },
      actioned: null,
      firstLoad: true,
      DROPOFF_SP: DROPOFF_SP,
      KERRY_DROPOFF: KERRY_DROPOFF,
      permission: {
        dropoffShippop: false,
        interParcelService: false,
        dropoffVRich: false,
        dropoffEasyShip: false,
        kerryDropoff: false,
        dropoffQuick: false,
      },
      orderExcel: {
        error: [],
      },
      sendCheck: 0,
      temp: true,
      searchSenderDetails: searchSenderDetails,
      searchRecipientDetails: searchRecipientDetails,
      focusOutRecipientDetails: focusOutRecipientDetails,
      getValueRecipientDetails: getValueRecipientDetails,
      currentError: "",
      crossPrice: 0,
      setTime: "",
      iconUrl: {},
      draftSpecialCode: null,
      searchCourier: "",
      searchProduct: "",
      selectedCourier: "",
      listPostcodeSpecial: {},
      storesender: new DataStore(),
      storefrom: new DataStore(),
      storeto: new DataStore(),
      storebarcode: new DataStore(),
      year: new Date().getFullYear(),
      showMenu: false,
      userlogin: [],
      createdBy: "",
      products: [],
      couriers: [],
      preBarcode: "",
      scanBarcode: "",
      tracking: "",
      shop_id: "",
      indexid: 1,
      cart: [],
      submitAddPrebarcode: false,
      submitAddShipping: false,
      submitAddService: false,
      errorIdCard: false,
      barcodeOk: false,
      errorBirthday: false,
      // errorPassport: false,
      errorBarcode: false,
      barcodeError: false,
      rateError: false,
      ratePreError: false,
      errorWeight: false,
      errorCodAmount: false,
      editOrdersAll: false,
      isToggle: false,
      isLoadingShip: false,
      isLoadingNewBill: false,
      isLoadingVRich: false,
      isLoadingEasyShip: false,
      isLoadingQuick: false,
      isLoadingCheckCod: false,
      recheckCOD: false,
      search: {
        recipient: "",
      },
      interParcelService: {
        data: {
          trackingCode: "",
          fromName: "",
          toName: "",
          weight: "",
          amount: "",
          fee: "",
          remark: "",
        },
        isShow: false,
      },
      titleName: "ที่อยู่ร้าน",
      date: "",
      prerate: 0,
      // show: false,
      firstmodal: "modal-idcard",
      // modalmoney: "modal-checkbill",
      modalparcel: "model-parcel",
      modalprebarcode: "modal-prebarcode",
      codCondition: {
        min: 100,
        max: 50000,
      },
      noti: {
        show: false,
        type: "",
        created_by: "",
        role: "",
        date_noti: "",
        router: false,
      },
      productAvoid: {
        show: false,
        key: "insurance",
        isBanner: false,
      },
      courierTeleport: {
        show: false,
      },
      courierTime: {
        show: false,
      },
      insuranceService: {
        show: false,
        insurance: null,
      },
      alertCredit: {
        show: false,
        creditPay: 0.0,
      },
      alertOverdue: {
        show: false,
      },
      wallet: 0,
      expired_date: "",
      dateNow: "",
      next_two_hour: "",
      shabuEVoucher: {
        show: false,
        shabu: null,
        code: "",
      },
      zendai: {
        show: false,
        zendai: {
          rate: 0,
        },
      },
      courierDropoffVRich: {},
      courierDropoffEasyShip: {},
      courierDropoffQuick: {},
      dropoffVRich: {
        show: false,
        trackingCode: "",
        shippopTrackingCode: "",
        purchaseId: "",
        datetimeCreateOrder: "",
      },
      dropoffQuick: {
        show: false,
        trackingCode: "",
        shippopTrackingCode: "",
        purchaseId: "",
        datetimeCreateOrder: "",
      },
      dropoffEasyShip: {
        show: false,
        trackingCode: "",
      },
      kerryDropoff: {
        show: false,
        isLoadingKerryDropoff: false,
        trackingCode: "",
        errorMsg: "",
      },
      pickup_type: "JNTD",
      sameData: "",
      weight: "",
      weightKG: "",
      keyBox: "",
      size: {
        boxSize: "",
      },
      width: "",
      length: "",
      height: "",
      codAmount: "",
      type: "",
      labeltype: "",
      typeOfLabel: "default",
      labeltypeDropoff: "",
      shippop: "",
      editorder: "",
      idorder: "",
      lock: "",
      lockpre: "",
      lockCod: "",
      lockDropoffShippop: "",
      lockDropoffVRich: "",
      lockDropoffEasyShip: "",
      lockDropoffQuick: "",
      lockKerryDropoff: "",
      lockCourierGen: "",
      busy: true,
      count: 1,
      orderIdByOne: "",
      errorCreateOrderByOne: {
        status: false,
        msg: "",
      },
      errorAlertParcel: {
        status: false,
        msg: "",
        disableButton: false,
      },
      addMoreOrder: {
        isShow: false,
        isActive: false,
        order: [],
        typeCourier: "",
      },
      dropoffShippopDetails: {
        isShow: false,
        labelSize: this.label,
        parcels: [
          {
            barcode: "",
            tracking_code: "",
            courier_tracking_code: "",
            weight: "",
            price: "5.00",
            num: 1,
            name: "Thailandpost",
            key: "THP",
            type: DROPOFF_SP,
            option: {
              btnLabel: true,
              loadingIco: false,
              error_input: {
                status: null,
                msg: "",
              },
            },
          },
        ],
      },
      cod_details: {
        isShow: false,
        couriers: [],
        isCod: false,
      },
      shop_setting: {
        how_to_use_cod: false,
      },
      validateAddress: {
        to: {
          state: {
            status: false,
            msg: null,
          },
          district: {
            status: false,
            msg: null,
          },
          province: {
            status: false,
            msg: null,
          },
          postcode: {
            status: false,
            msg: null,
          },
        },
        from: {
          state: {
            status: false,
            msg: null,
          },
          district: {
            status: false,
            msg: null,
          },
          province: {
            status: false,
            msg: null,
          },
          postcode: {
            status: false,
            msg: null,
          },
        },
      },
      validate: {
        modalParcel: {
          checkDimension: {
            status: true,
            msg: "",
          },
          dimension: {
            width: {
              status: true,
              msg: "",
            },
            length: {
              status: true,
              msg: "",
            },
            height: {
              status: true,
              msg: "",
            },
          },
        },
      },
      checkBill: {
        show: false,
        changeMoney: 0,
        receiveMoney: "",
        discountAmount: "",
      },
      remote_area: {
        rate: 0,
      },
      from: {
        source: 0,
        address: "",
        district: "",
        latlng: "",
        name: "",
        postcode: "",
        province: "",
        state: "",
        tel: "",
        email: "",
      },
      to: {
        address: "",
        district: "",
        latlng: "",
        name: "",
        postcode: "",
        province: "",
        state: "",
        tel: "",
      },
      sender: {
        id_no: "",
        name: "",
        birthday: "",
        tel: "",
        address: "",
        customer_type: "0",
        state: "",
        district: "",
        postcode: "",
        province: "",
        tax: "",
        identity: false,
        mem_id: 0,
      },
      label: "a5",
      cod: "",
      fee: {
        name: "",
        rate: "",
        fee: "",
        serviceOther: "",
        remark: "",
      },
      courier_allow: [],
      shubuVoucherAllow: {},
      insurance: {
        error: {
          status: false,
          type: null,
          msg: "",
        },
        id: 0,
        isCheck: false,
        declared_value: "",
        category: "",
        remark: "",
        listRates: [],
        listPrice: {
          cost: 0,
          rate: 0,
          price: 0,
        },
      },
      expired_date: "",
      dateNow: "",
      next_two_hour: "",
    };
  },
  validations: {
    weight: { required },
    weightKG: { required },
    codAmount: { required },
    scanBarcode: { required, minLength: minLength(6) },
    sender: {
      id_no: {
        required,
        minLength: minLength(7),
        maxLength: maxLength(30),
      },
      name: { required, maxLength: maxLength(50) },
      tel: {
        numeric,
        minLength: minLength(9),
        maxLength: maxLength(15),
      },
      address: { required, maxLength: maxLength(200) },
      district: { required, maxLength: maxLength(50) },
      state: { required, maxLength: maxLength(50) },
      province: { required, maxLength: maxLength(50) },
      postcode: {
        numeric,
        minLength: minLength(5),
        maxLength: maxLength(5),
      },
      tax: { numeric, maxLength: maxLength(50) },
    },
    from: {
      address: { required },
      district: { required },
      name: { required },
      postcode: {
        required,
        numeric,
        minLength: minLength(5),
        maxLength: maxLength(5),
      },
      province: { required },
      state: { required },
      tel: {
        required,
        // numeric,
        isTelValid: helpers.regex("isTelValid", /^[+|0-9][0-9]*$/i),
        minLength: minLength(9),
        maxLength: maxLength(14),
      },
    },
    to: {
      address: { required },
      district: { required },
      name: { required },
      postcode: {
        required,
        numeric,
        minLength: minLength(5),
        maxLength: maxLength(5),
      },
      province: { required },
      state: { required },
      tel: {
        required,
        // numeric,
        isTelValid: helpers.regex("isTelValid", /^[+|0-9][0-9]*$/i),
        minLength: minLength(9),
        maxLength: maxLength(14),
      },
    },
    insurance: {
      declared_value: { required },
      category: { required },
      remark: { required },
    },
  },
  beforeRouteLeave(to, from, next) {
    // ถามก่อนที่จะออกจากหน้านี้
    if (confirm("คุณต้องการออกจากหน้านี้หรือไม่?")) {
      next();
    } else {
      // ยกเลิกการนำทาง
      next(false);
    }
  },
  mounted() {
    window.onbeforeunload = function (e) {
      var confirmationMessage = "คุณแน่ใจหรือไม่ที่จะออกจากหน้านี้?";
      (e || window.event).returnValue = confirmationMessage;
      return confirmationMessage;
    };
    this.defaultLoad();

    let now = moment(new Date(Date.now())).format("YYYY-MM-DD HH:mm:ss");
    let next_two_hour = moment().add(2, "hours").format("YYYY-MM-DD HH:mm:ss");
    this.next_two_hour = next_two_hour;
    this.dateNow = now;
  },
  components: {
    CreateOrderByExcel: PosComponents.CreateOrderByExcel,
    DropoffShippop: PosComponents.DropoffShippop,
    AutoBox,
    AutocompletesOrigin,
    AutocompletesAddress,
    CardPos,
    CardItems,
    draggable,
    ModalNotification,
    SlideYUpTransition,
    RadioBox,
    CodCourierList,
    TableAddOrders,
    ModalProductAvoid,
    ModalInsurance,
    ModalService,
    ModalAlertRemoteArea,
    InterParcelService,
    NavbarPos,
    InputParcelType,
    ParcelInsurance,
    ModalAlertCredit,
    ModelAlertOverdueBalance,
    ModalCourierTeleport,
    ModalShabuEVoucher,
    ModalZendai,
    ModalCheckBill,
    SearchTracking,
    KerryDropoff,
    ModalSender,
  },
  async created() {
    await this.beforeGetShop();
    this.checkListDaft();
  },
  methods: {
    printLabelByOne() {
      const details = {
        sender_name: this.sender.name,
        sender_tel: this.sender.tel,
        sender_address: `${this.sender.address} ${this.sender.state} ${this.sender.district} ${this.sender.province}`,
        sender_postcode: this.sender.postcode,
        re_tel: this.to.tel,
        re_name: this.to.name,
        re_address: `${this.to.address} ${this.to.state} ${this.to.district} ${this.to.province}`,
        re_postcode: this.to.postcode,
        tracking_code: this.tracking,
        weight: this.weight,
      };
      const newWindow = window.open("about:blank");
      newWindow.document.write(_LABEL_(details));
      newWindow.document.close();
      newWindow.print();
    },
    checkListDaft() {
      // ดึงข้อมูลจาก localStorage
      const savedData = localStorage.getItem("list_draft");

      if (savedData) {
        if (confirm("ต้องการโหลดข้อมูลก่อนหน้านี้หรือไม่ ?")) {
          const data = JSON.parse(savedData);
          this.sender = data.sender;
          this.cart = data.cart;
          console.log(data.sender);
          console.log(data.cart);
        } else {
          this.removeListDaftStorage();
        }
      }
    },
    openRegisterCOD() {
      this.recheckCOD = true;
      window.open(`/#/registermember/${this.from.email}`, "_blank");
    },
    tabActiveCheckCOD() {
      window.addEventListener("focus", () => {
        if (this.recheckCOD) {
          this.recheckCOD = false;
          this.isLoadingCheckCod = true;

          checkMemberCod(this.sender.tel, this.sender.id_no)
            .then((res) => {
              this.isLoadingCheckCod = false;
              if (!res.status) {
                this.sender.identity = false;
              }
              if (res.status === "is member") {
                this.sender.identity = true;
                this.sender.mem_id = res.mem_id;
              } else {
                this.sender.identity = false;
              }
              //setLocalStorage Update For Sender
              setLocalStorage.sender().set(this.sender);
            })
            .catch(() => {});
        }
      });
    },
    setPatchPrintLabel() {
      //  <!-- :to="`/label/${idorder}/${label}/${typeOfLabel}`" -->
      if (this.filterCheckDropoffVRich) {
        let trackingCodes = [];
        this.cartShipping.forEach((item) => {
          trackingCodes.push(item.shippop_tracking_code);
        });
        trackingCodes = trackingCodes.join();
        return `/label/${trackingCodes}/${this.label}/VRich`;
      }
      return `/label/${this.idorder}/${this.label}/${this.typeOfLabel}`;
    },
    async checkTrackingQuick() {
      this.isLoadingQuick = true;

      let uniqueTrackingQuick = this.cartDropoffQuick.filter((quick) => {
        return quick.dropoff_tracking_code === this.dropoffQuick.trackingCode;
      });

      if (uniqueTrackingQuick.length > 0) {
        this.vRich.errorMsg = `ไม่สามารถสร้างรายการ DROP OFF QUICK ได้ เนื่องจากหมายเลขพัสดุ ${this.dropoffQuick.trackingCode} นี้ ถูกใช้งานไปแล้ว`;
        this.isLoadingQuick = false;
        return false;
      }

      await searchTrackingDropoff(
        this.dropoffQuick.trackingCode,
        "QUICK_DROPOFF"
      )
        .then((resData) => {
          this.isLoadingQuick = false;
          this.dropoffQuick.shippopTrackingCode = resData.tracking_code;
          this.dropoffQuick.purchaseId = resData.purchase_id;
          this.dropoffQuick.datetimeCreateOrder = resData.datetime_order;
          if (
            resData.hasOwnProperty("insurance") &&
            resData.insurance.declared_value > 0
          ) {
            this.insurance.isCheck = true;
            this.insurance.declared_value = resData.insurance.declared_value;
            this.$refs.parcelInsurance.getRate();
            this.$refs.inputParcelType.seleted(
              {
                key: resData.insurance.category_key,
                name: resData.insurance.category_name,
              },
              "onSeleted"
            );
          }
          sound("positiveBeep");
          this.mapDetailsTrackingDropoff(resData);
        })
        .catch((e) => {
          sound("beepFail");
          this.isLoadingQuick = false;
          this.quick.errorMsg = e;
        });
    },
    async checkTrackingVRich() {
      this.isLoadingVRich = true;

      let uniqueTrackingVRich = this.cartDropoffVRich.filter((vrich) => {
        return vrich.dropoff_tracking_code === this.dropoffVRich.trackingCode;
      });

      if (uniqueTrackingVRich.length > 0) {
        sound("beepFail");
        this.vRich.errorMsg = `ไม่สามารถสร้างรายการ V RICH ได้ เนื่องจากหมายเลขพัสดุ ${this.dropoffVRich.trackingCode} นี้ ถูกใช้งานไปแล้ว`;
        this.isLoadingVRich = false;
        return false;
      }

      await searchTrackingDropoff(this.dropoffVRich.trackingCode)
        .then((resData) => {
          this.isLoadingVRich = false;
          this.dropoffVRich.shippopTrackingCode = resData.tracking_code;
          this.dropoffVRich.purchaseId = resData.purchase_id;
          this.dropoffVRich.datetimeCreateOrder = resData.datetime_order;
          sound("positiveBeep");
          this.mapDetailsTrackingDropoff(resData);
        })
        .catch((e) => {
          sound("beepFail");
          this.isLoadingVRich = false;
          this.quick.errorMsg = e;
        });
    },
    mapDetailsTrackingDropoff(resData) {
      this.from.address = resData.from.address;
      this.from.district = resData.from.city;
      this.from.name = resData.from.name;
      this.from.postcode = resData.from.postcode;
      this.from.province = resData.from.province;
      this.from.state = resData.from.district;
      this.from.tel = resData.from.phone;
      this.from.email = resData.from.email;
      this.to.address = resData.to.address;
      this.to.district = resData.to.city;
      this.to.name = resData.to.name;
      this.to.postcode = resData.to.postcode;
      this.to.province = resData.to.province;
      this.to.state = resData.to.district;
      this.to.tel = resData.to.phone;
      this.tracking = resData.courier_tracking_code;
      this.codAmount = resData.cod_amount;
      if (this.codAmount > 0) {
        this.cod_details.isCod = true;
      }
    },
    checkTrackingEasyShip() {
      this.isLoadingEasyShip = true;
      this.$http
        .get(this.$API_URL + "/dropoff/easy-ship/shipment", {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
          params: {
            tracking_code: this.dropoffEasyShip.trackingCode,
          },
        })
        .then((res) => {
          this.isLoadingEasyShip = false;

          let checkError = validatePop(res);
          if (!checkError.status) {
            sound("beepFail");
            this.isLoadingEasyShip = false;
            this.easyShip.errorMsg = checkError.msg;
            return false;
          }
          sound("positiveBeep");
          let resData = res.data.data.data;

          this.from.name = resData.senderInfo.senderName;
          this.from.tel = resData.senderInfo.senderMobile;
          this.to.address = resData.recipientInfo.recipientAddress;
          this.to.district = resData.recipientInfo.recipientAmphur;
          this.to.name = resData.recipientInfo.recipientName;
          this.to.postcode = resData.recipientInfo.recipientZipcode;
          this.to.province = resData.recipientInfo.recipientProvince;
          this.to.state = resData.recipientInfo.recipientTambon;
          this.to.tel = resData.recipientInfo.recipientMobile;

          this.codAmount = resData.codInfo.codAmount;

          if (this.codAmount > 0) {
            this.cod_details.isCod = true;
          }
        })
        .catch((error) => {
          sound("beepFail");
          this.isLoadingEasyShip = false;
          this.showErrorModal(
            " พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #033 "
          );
        });
    },
    openModalEVoucher() {
      this.shabuEVoucher.show = true;
    },
    defaultLoad() {
      // nuttakorn
      this.getUserlogin();
      this.checkCreateBy();
    },
    getUserlogin() {
      this.userlogin = JSON.parse(localStorage.getItem("user"));
    },
    checkCreateBy() {
      this.createdBy = this.userlogin.under_by;
    },
    closeModalProductAvoid() {
      if (this.firstLoad) {
        this.switchFirstLoad();
        this.productAvoid.isBanner = false;
      }
      this.productAvoid.show = false;
    },
    switchFirstLoad() {
      this.firstLoad = !this.firstLoad;
    },
    onSubmitAddress(ads, objKey) {
      Object.keys(this[objKey]).forEach((key) => {
        if (ads[key]) {
          this[objKey][key] = ads[key];
        } else if (key == "state") {
          this[objKey]["state"] = ads["sub-district"];
        } else {
          this[objKey][key] = this[objKey][key];
        }
      });
    },
    moveProduct() {
      this.busy = true;
      this.productFilter.map((data, index) => {
        data.pointer_item = index + 1;
      });
      const itemProduct = {};
      this.productFilter.forEach((item) => {
        itemProduct[item.id] = { pointer_item: item.pointer_item };
      });

      this.$http
        .put(
          API_URL + "/shop/product/pointer",
          {
            pointer_item: itemProduct,
          },
          {
            headers: { Token: localStorage.getItem("access_token") },
          }
        )
        .then((res) => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            this.busy = false;
            this.showErrorModal(checkError.msg);
            return false;
          }
          this.busy = false;
          this.showSuccessModal("บันทึกข้อมูลสำเร็จ");
        })
        .catch(() => {});
    },
    onSubmitOriginAutocomp(item) {
      Object.keys(this.from).forEach((key) => {
        if (item[key]) {
          this.from[key] = item[key];
        } else {
          this.from[key] = this.from[key];
        }
      });
    },
    onSubmitRecipient(result) {
      this.to.name = result.name;
      this.to.tel = result.tel;
      this.to.address = result.address;
      this.to.district = result.state;
      this.to.state = result.district;
      this.to.province = result.province;
      this.to.postcode = result.postcode;
    },
    addOrderInterParcel() {
      const parcel = this.interParcelService.data;
      let formatAddtoCart = {
        key: "SPINTERPAECEL",
        check: this.count++,
        type: "service",
        trackingCode: parcel.trackingCode,
        num: 1,
        name: "shippop inter parcel",
        rate: parcel.amount,
        fee: parcel.fee,
        price: Number(parcel.amount) + Number(parcel.fee),
        weight: parcel.weight,
        from: parcel.fromName,
        to: parcel.toName,
        remark: parcel.remark,
      };
      this.cart.push(formatAddtoCart);

      if (this.checkThemeQuick()) {
        setLocalStorage.orderCart().set(this.cart);
      }
    },
    addService() {
      let service = {
        type: "service",
        num: 1,
        name: this.fee.name,
        rate: this.fee.rate,
        fee: this.fee.fee,
        remark: this.fee.remark,
        price: Number(this.fee.rate) + Number(this.fee.fee),
        check: this.count++,
      };
      this.cart.push(service);
      if (this.checkThemeQuick()) {
        setLocalStorage.orderCart().set(this.cart);
      }
    },
    addZendai() {
      let zendai = {
        type: "zendai",
        num: 1,
        name: "สินค้าร่วมสนับสนุนการทำงานของเส้นด้าย",
        rate: this.zendai.rate,
        fee: "0.00",
        price: Number(this.zendai.rate),
        check: this.count++,
      };
      this.cart.push(zendai);
      this.$refs.zendai.clearZendai();
    },
    confirmCreateKerryDropoff(kerryDropoff) {
      this.cart = this.cart.concat(kerryDropoff);
      this.$refs.kerryDropoff.kerryOrder = [];
      this.kerryDropoff.show = false;
      this.kerryDropoff.trackingCode = "";
      this.kerryDropoff.errorMsg = "";

      if (this.checkThemeQuick()) {
        setLocalStorage.orderCart().set(this.cart);
        setLocalStorage.batchNo().set(this.$refs.kerryDropoff.batchId);
      }

      this.checkDisableCardCourier();
    },
    clearInsurance() {
      this.$refs.insurance.switchModal = "select";
      this.insuranceService.show = false;
      this.insuranceService.insurance = null;
    },
    clearShabuEVoucher() {
      this.$refs.shabu.switchModal = "select";
      this.shabuEVoucher.show = false;
      this.shabuEVoucher.shabu = null;
      this.shabuEVoucher.code = "";
    },
    addShabuEVoucher() {
      let shabuEVoucher = {
        type: "eVoucher",
        num: 1,
        name: this.shabuEVoucher.shabu.name,
        rate: this.shabuEVoucher.shabu.rate,
        fee: "0.00",
        price: Number(this.shabuEVoucher.shabu.rate),
        check: this.count++,
        barcode: this.shabuEVoucher.code,
      };
      this.cart.push(shabuEVoucher);
      this.clearShabuEVoucher();
    },
    addInsurance() {
      let insurance = {
        type: "insurance",
        num: 1,
        name: this.insuranceService.insurance.name,
        rate: this.insuranceService.insurance.rate,
        fee: "0.00",
        price: Number(this.insuranceService.insurance.rate),
        check: this.count++,
      };
      this.cart.push(insurance);
      this.clearInsurance();
    },
    addDropoffShippopOrder() {
      this.cart.push(...this.dropoffShippopDetails.parcels);
      this.lock = "lock";
      this.lockpre = "lock";
      this.lockCourierGen = "lock";
    },
    addToCart(product) {
      const matchingProductIndex = this.cart.findIndex((item) => {
        return item.id == product.id;
      });
      product.type = "item";
      if (matchingProductIndex > -1) {
        this.cart[matchingProductIndex].num++;
        this.cart[matchingProductIndex].qtytotal =
          this.cart[matchingProductIndex].num *
          this.cart[matchingProductIndex].price;
      } else {
        product.num = 1;
        product.qtytotal = product.price;
        product.check = this.count++;
        this.cart.push(product);
      }
      this.cart.sort((a, b) => {
        return a.id < b.id;
      });

      if (this.checkThemeQuick()) {
        setLocalStorage.orderCart().set(this.cart);
      }
    },
    async cancelBeforeRemoveTotal(check, type = "default") {
      if (this.checkThemeQuick()) {
        let indexOfCart = this.cart.findIndex((item) => item.check == check);

        if (this.cart[indexOfCart].order_detail_id) {
          this.busy = true;

          cancelOrderByOne(this.orderIdByOne, [
            this.cart[indexOfCart].order_detail_id,
          ]).then((results) => {
            if (results.status) {
              const countListFail = results.data.list_fail.length;
              this.busy = false;

              if (countListFail < 1) {
                this.removeTotal(check, type);
                this.showSuccessModal("ลบรายการเสร็จเรียบร้อยแล้ว");
                return true;
              } else {
                this.showErrorModal(
                  `ไม่สามารถยกเลิกรายการได้ ${results.data.receipt_id}`
                );
                return false;
              }
            }
          });
        } else {
          this.removeTotal(check, type);
        }
      }
    },
    async removeTotal(check, type = "default") {
      let indexOfCart = this.cart.findIndex((item) => item.check == check);

      if (this.filterCheckKerryDropoff) {
        await deleteShipment(
          this.$refs.kerryDropoff.batchId,
          this.cart[indexOfCart].dropoff_tracking_code,
          this.cart[indexOfCart].consignment_no_ref
        )
          .then((res) => {})
          .catch((e) => {
            this.showErrorModal(e);
          });
      }

      if (type == "default") {
        this.cart.splice(indexOfCart, 1);
      } else {
        this.cart.splice(check, 1);
      }

      if (this.checkThemeQuick()) {
        setLocalStorage.orderCart().set(this.cart);
      }

      const checktype = this.cart.findIndex((ship) => {
        return ship.type === "ship";
      });
      const checkcourier = this.cartShipping.findIndex((ship) => {
        return ship.key !== "GEN";
      });
      const checkDropoffShippop = this.cartDropoffShippop.findIndex((ship) => {
        return ship.type == DROPOFF_SP;
      });
      if (checktype < 0 && checkDropoffShippop < 0 && checkcourier < 0) {
        this.lock = "";
        this.lockpre = "";
        this.lockDropoffShippop = "";
        this.lockDropoffVRich = "";
        this.lockDropoffEasyShip = "";
        this.lockDropoffQuick = "";
        this.lockKerryDropoff = "";
        this.lockCourierGen = "";
        this.orderIdByOne = "";
        this.reStartOrderByOne();
      }
    },
    async reStartOrderByOne() {
      return true;
    },
    reload(item) {
      this.cart.sort((a, b) => {
        return a.id < b.id;
      });
      item.qtytotal = item.price * item.num;
    },
    scrollToError() {
      this.busy = false;
      if (this.currentError.$el) {
        this.currentError = this.currentError.$el;
      }
      this.currentError.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    async checkIdCard(event) {
      this.busy = true;
      this.$refs.modalSender.submitAddIdCard = true;
      this.$refs.modalSender.$v.sender.$touch();
      if (this.$refs.modalSender.$v.sender.$invalid) {
        for (let k in this.$refs.modalSender.$v.sender.$params) {
          if (this.$refs.modalSender.$v.sender[k].$error) {
            this.currentError = this.$refs.modalSender.$refs["sender_" + k];
            this.scrollToError();
            return false;
          }
        }
      }
      if (
        this.sender.id_no.length == 13 &&
        /^([0-9]{1,})$/.test(this.sender.id_no)
      ) {
        let checkCardId = checkPersonID(this.sender.id_no);
        this.errorIdCard = false;
        if (!checkCardId) {
          this.errorIdCard = true;
          this.currentError = this.$ref.modalSender.$refs.sender_id_no;
          this.scrollToError();
          return false;
        }
      }
      if (this.sender.birthday) {
        if (moment(this.sender.birthday, "DD-MM-YYYY").isValid() == false) {
          this.errorBirthday = true;
          this.currentError = this.$ref.modalSender.$refs.sender_birthday;
          this.scrollToError();
          return false;
        }
        this.errorBirthday = false;
        let date = this.sender.birthday.split("/");
        if (date.length < 3) {
          this.errorBirthday = true;
          this.currentError = this.$ref.modalSender.$refs.sender_birthday;
          this.scrollToError();
          return false;
        }

        let day = date[0];
        let month = date[1];
        let year = date[2] - 543;

        if (isNaN(day) || isNaN(month) || isNaN(year)) {
          this.errorBirthday = true;
          this.currentError = this.$ref.modalSender.$refs.sender_birthday;
          this.scrollToError();
          return false;
        }

        let age = moment().format("YYYY") - year;

        if (age >= 100 || age < 0) {
          this.errorBirthday = true;
          this.currentError = this.$ref.modalSender.$refs.sender_birthday;
          this.scrollToError();
          return false;
        }

        if (day.length < 2 && month.length < 2) {
          day = "0" + date[0];
          month = "0" + date[1];
        } else if (day.length < 2) {
          day = "0" + date[0];
        } else if (month.length < 2) {
          month = "0" + date[1];
        }

        this.sender.birthday = year + "-" + month + "-" + day;
      }
      await this.checkVerifyMemberCod();
      if (event == "prebarcode") {
        this.$refs[this.modalprebarcode].show();
      } else if (event == DROPOFF_SP) {
        this.dropoffShippopDetails.isShow = true;
      } else if (event == "INTER_PARCEL") {
        this.interParcelService.isShow = true;
      } else if (this.cod_details.isCod && this.lockCod == "lock") {
        this.cod_details.isCod = false;
        this.showErrorModal(
          "กรุณาสมัครสมาชิก COD ที่หน้าจัดการลูกค้า ***แต่ยังสามารถสร้างรายการที่ไม่ใช่ COD ได้ตามปกติ***",
          "Done"
        );
      } else {
        if (this.sender.name != "") {
          this.from.name = this.sender.name;
          this.from.address = this.sender.address;
          this.from.state = this.sender.state;
          this.from.district = this.sender.district;
          this.from.province = this.sender.province;
          this.from.postcode = this.sender.postcode;
          this.from.tel = this.sender.tel;
          this.titleName = "ที่อยู่ตามบัตรประชาชน";
        }

        if (event == KERRY_DROPOFF) {
          this.kerryDropoff.show = true;
        } else {
          this.$refs[this.modalparcel].show();
        }
      }
    },
    async checkVerifyMemberCod() {
      this.cod_details.isCod = false;
      this.busy = false;
      return false;
    },
    handleModalCreateOrder(typeCourier) {
      if (typeCourier) {
        this.$refs[this.modalprebarcode].show();
      } else {
        this.$refs[this.modalparcel].show();
      }
    },
    async editParcel(check) {
      let detail;
      let id = check;
      if (Array.isArray(check)) {
        id = check[0].check;
        detail = check.filter((item) => {
          return item.check === id;
        });
      } else {
        this.editOrdersAll = true;
        detail = this.cartShipping.filter((item) => {
          return item.check === check;
        });
      }
      await this.getIcon(detail[0].courier).then((res) => {
        this.iconUrl = res;
      });

      if (detail[0].cod_amount || detail[0].cod_amount === null) {
        this.cod_details.isCod = true;
      }
      // if( detail[0].error.status ){

      //   detail[0].error.status = false
      //   detail[0].error.msg = ""

      // }
      this.selectModalEdit(detail[0].courier.prebarcode);
      await this.$nextTick(() => {
        this.draftSpecialCode = detail[0].special_code;
        this.from.name = detail[0].from.name;
        this.from.address = detail[0].from.address;
        this.from.state = detail[0].from.state;
        this.from.district = detail[0].from.district;
        this.from.province = detail[0].from.province;
        this.from.postcode = detail[0].from.postcode;
        this.from.tel = detail[0].from.tel;
        this.titleName = "ที่อยู่ตามบัตรประชาชน";
        this.codAmount = detail[0].cod_amount;
        this.pickup_type = detail[0].pickup_type;
        this.selectedCourier = detail[0].courier;
        this.to.name = detail[0].to.name;
        this.to.tel = detail[0].to.tel;
        this.to.address = detail[0].to.address;
        this.to.district = detail[0].to.state;
        this.to.state = detail[0].to.district;
        this.to.province = detail[0].to.province;
        this.to.postcode = detail[0].to.postcode;
        this.weight = detail[0].parcel.weight;
        this.weightKG = detail[0].parcel.weightKG;
        this.width = detail[0].parcel.width;
        this.length = detail[0].parcel.length;
        this.height = detail[0].parcel.height;
        this.scanBarcode = detail[0].pre_barcode;
        this.editorder = id;
        this.prerate = detail[0].price;
        this.tracking = detail[0].pre_tracking;
        this.size.boxSize = detail[0].parcel.key_size;
        detail[0].from.addressType
          ? (this.isToggle = true)
          : (this.isToggle = false);
        this.setValueInsuranceFromEdit(detail[0].insurance);
      });
      this.itemPreRate();
    },
    setValueInsuranceFromEdit(value) {
      this.insurance = JSON.parse(JSON.stringify(value));
    },
    clearInputInsurance() {
      this.insurance.id = 0;
      this.insurance.declared_value = "";
      this.insurance.category = "";
      this.insurance.isCheck = false;
      this.insurance.remark = "";
      for (const key in this.insurance.listPrice) {
        this.insurance.listPrice[key] = 0;
      }
      return this.insurance;
    },
    selectModalEdit(prebarcode) {
      return new Promise((resolve, reject) => {
        if (prebarcode == 1) {
          this.$refs[this.modalprebarcode].show();
        } else {
          this.$refs[this.modalparcel].show();
        }
        resolve(true);
      });
    },
    async beforeGetShop() {
      await this.getShop(0);
    },
    setCourierPostcodeDetails(cpd) {
      if (cpd["msg"] == "get latest version") {
        localStorage.setItem("courier_postcode", JSON.stringify(cpd.data));
      }
      this.listPostcodeSpecial = JSON.parse(
        localStorage.getItem("courier_postcode")
      );
    },
    isExpired(expired_date) {
      // check courier dropoff expired
      return !expired_date || moment().valueOf > moment(expired_date).valueOf();
    },
    async getShop(cpd) {
      await this.$http
        .get(API_URL + `/shop/${cpd}`, {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
        })
        .then((res) => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            this.showErrorModal(checkError.msg);
            return false;
          }
          let _res = res.data.data;
          res.data.data.items.sort((a, b) => {
            return a.pointer_item - b.pointer_item;
          });
          this.setCourierPostcodeDetails(_res.courier_postcode_details);
          this.products = _res.items;
          this.couriers = _res.couriers;

          let courierCodeKRYQ = this.couriers.filter(
            (courier) =>
              courier.key == "KRYQ" && this.isExpired(courier.expired_date)
          );
          if (this.checkThemeQuick() && courierCodeKRYQ.length > 0) {
            this.courierDropoffVRich = courierCodeKRYQ[0];
            this.courierDropoffEasyShip = courierCodeKRYQ[0];
            this.courierDropoffQuick = courierCodeKRYQ[0];
            this.permission.dropoffQuick = true; // dropoff EasyQuick
          } else {
            let courierCodeKRYS = this.couriers.filter(
              (courier) =>
                courier.key == "KRYS" && this.isExpired(courier.expired_date)
            );
            if (courierCodeKRYS.length > 0) {
              this.courierDropoffEasyShip = courierCodeKRYS[0];
            }
          }

          this.sameData = {
            name: _res.name,
            address: _res.address,
            district: _res.district,
            state: _res.state,
            province: _res.province,
            postcode: _res.postcode,
            tel: _res.tel,
          };
          this.label = _res.default_label_size;
          this.cod = _res.allow_cod;
          this.shop_id = _res.id;
          this.courier_allow = _res.courier_allow;
          this.shubuVoucherAllow = _res.shabu_voucher_allow;
          this.permission.dropoffShippop = _res.setting.allow_dropoff_shippop;
          this.permission.interParcelService =
            _res.setting.allow_inter_parcel_service;
          this.permission.dropoffVRich = this.$THEME.dropoffVRich;
          this.checkPermissionDropoffEasyShip();
          this.permission.kerryDropoff = this.$THEME.dropoffKerry
            ? true
            : _res.setting.dropoff.hasOwnProperty("KERRY_DROPOFF")
            ? _res.setting.dropoff.KERRY_DROPOFF.status
            : false;
          this.shop_setting = _res.setting;
          this.insurance.listRates = _res.insurance;
        })
        .catch((error) => {
          console.log(error);
          this.showErrorModal(
            " พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #010 "
          );
        })
        .finally(() => {
          this.busy = false;
        });
    },
    checkPermissionDropoffEasyShip() {
      if (
        this.$THEME.dropoffEasyShip ||
        (this.$THEME.name == "shippop" &&
          (this.shop_id == 1968 || this.shop_id == 2168)) // for test on Headquater
      ) {
        if (
          this.courierDropoffEasyShip.key &&
          ["KRYS", "KRYQ"].includes(this.courierDropoffEasyShip.key)
        ) {
          this.permission.dropoffEasyShip = true;
        } else {
          this.permission.dropoffEasyShip = false;
        }
      } else {
        this.permission.dropoffEasyShip = false;
      }
      return this.permission.dropoffEasyShip;
    },
    showCourier(courier) {
      const effect = this.checkEffectiveDate(courier.effective_date);
      const expired = this.checkExpiredDate(courier.expired_date);
      return expired && effect;
    },
    checkExpiredDate(expired) {
      if (expired === null) return true;
      if (expired <= this.dateNow) return false;
      return true;
    },
    checkEffectiveDate(effect) {
      if (effect === null) return true;
      if (effect > this.dateNow) return false;
      return true;
    },
    courierModalTime(courier, prebarcode) {
      if (courier.expired_date != null) {
        this.expired_date = courier.expired_date.toString();
        this.dateNow = moment().valueOf();
        if (this.dateNow <= moment(courier.expired_date).valueOf()) {
          if (
            !getCookie("courier_change_rate") &&
            moment().add(7, "day").valueOf() >=
              moment(courier.expired_date).valueOf()
          ) {
            setCookie("courier_change_rate", 1, "1hr");
            this.courierTime.show = true;
          }
          this.openModal(courier, prebarcode);
        } else {
          alert("ราคามีการเปลี่ยนแปลงกรุณาเลือกขนส่งอื่น");
        }
      } else {
        this.openModal(courier, prebarcode);
      }
    },
    closeModalCourierTime() {
      this.courierTime.show = false;
    },
    removeListDaftStorage() {
      localStorage.removeItem("list_draft");
    },
    buyTotal() {
      if (this.sendCheck > 0) {
        return false;
      }
      this.sendCheck = 1;
      this.busy = true;
      const order = [];
      let copyCard = JSON.parse(JSON.stringify(this.cart));
      copyCard.forEach((item) => {
        if (item.courier) {
          delete item.courier;
        }
        if (item.type == "item") {
          item.refer_id = item.id;
        }
        order.push(item);
      });
      this.checkBill.show = false;
      let URL = "/v2/order";
      this.$http
        .post(
          API_URL + URL,
          {
            orders: order,
            cash: this.checkBill.receiveMoney,
            discount: this.checkBill.discountAmount,
            sender: {
              id_no: this.sender.id_no,
              name: this.sender.name,
              birthday: null,
              tel: this.sender.tel,
              address: this.sender.address,
              state: this.sender.state,
              district: this.sender.district,
              province: this.sender.province,
              postcode: this.sender.postcode,
              customer_type: this.sender.customer_type,
              tax: this.sender.tax,
              mem_id: this.sender.mem_id,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
              Token: localStorage.getItem("access_token"),
            },
          }
        )
        .then((res) => {
          let checkError = validatePop(res);

          if (!checkError.status) {
            this.busy = false;

            if (
              typeof checkError.data != "undefined" &&
              checkError.data != null
            ) {
              this.setErrorAfterCreateOrder(checkError.data);
            }

            this.showErrorModal(checkError.msg);
            this.sendCheck = 0;
            return false;
          }
          this.busy = false;
          this.idorder = res.data.data.order.id;
          this.labeltype = res.data.data.order.ship_price;
          printReceipt(res.data.data.receiptHTML);
          this.shippop = 0;
          this.sendCheck = 1;
          this.removeListDaftStorage();
          this.showSuccessModal("ทำรายการเสร็จเรียบร้อยค่ะ กรุณาเปิดบิลใหม่");
        })
        .catch((error) => {
          console.log("buytotal", error);
          this.busy = false;
          this.idorder = "0";
          this.showErrorModal(
            " พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #011 "
          );
        });
    },
    setErrorAfterCreateOrder(data) {
      data.forEach((value) => {
        const i = value.indexOfParcel;
        let msg = value.msg;
        this.cart[i].error.status = true;
        this.cart[i].error.msg = msg;
      });
    },
    async getIcon(courier) {
      let icon = {};
      // if (!courier.icon) {
      //   icon = { status: false, courierName: courier.name, url: null };
      // } else {
      //   icon = { status: true, courierName: courier.name, url: "img/brand/load-error.svg" };
      // }
      icon = {
        status: true,
        courierName: courier.name,
        url: "img/brand/load-error.svg",
      };

      return icon;
    },
    openModal(courier, preBarcode) {
      this.busy = true;

      if (this.sender.name != "") {
        this.from.name = this.sender.name;
        this.from.address = this.sender.address;
        this.from.state = this.sender.state;
        this.from.district = this.sender.district;
        this.from.province = this.sender.province;
        this.from.postcode = this.sender.postcode;
        this.from.tel = this.sender.tel;
        this.titleName = "ที่อยู่ตามบัตรประชาชน";
      }

      if (courier === "COD") {
        this.cod_details.isShow = true;
        this.cod_details.couriers = this.couriers.filter((courier) => {
          return this.showCourier(courier);
        });
      } else if (courier === DROPOFF_SP) {
        this.preBarcode = DROPOFF_SP;

        if (this.sender.name == "") {
          this.$refs.modalSender.$refs["modal-idcard"].show();
        } else {
          this.dropoffShippopDetails.isShow = true;
        }
      } else if (courier == "INTER_PARCEL") {
        this.preBarcode = "INTER_PARCEL";
        if (this.sender.name == "") {
          this.$refs.modalSender.$refs["modal-idcard"].show();
        } else {
          this.interParcelService.isShow = true;
        }
      } else if (courier === KERRY_DROPOFF) {
        this.preBarcode = KERRY_DROPOFF;

        if (this.sender.name == "") {
          this.$refs.modalSender.$refs["modal-idcard"].show();
        } else {
          this.kerryDropoff.show = true;
        }
      } else {
        // if( courier.key == "TRUE" ){
        //   this.showNotiModal('ขนส่งนี้ ต้องมียอดการจัดส่งพัสดุขั้นต่ำ 3 ชิ้นขึ้นไป เปิดให้ใช้บริการเข้ารับพัสดุและจัดส่งเฉพาะพื้นที่โซน กทม.และ ปริมณฑล เท่านั้น')
        // }
        if (courierRules.alertBeforeCreateOrderCouriers.includes(courier.key)) {
          if (courier.key == "TPSD") {
            this.courierTeleport.show = true;
          } else {
            let style = courier.key === "DHL" ? { text: "text-left" } : {};
            this.showNotiModal(
              courierRules[courier.key].alertText.text,
              courierRules[courier.key].alertText.emphasize,
              style
            );
          }
        }

        if (!this.checkWorkingHours(courier.key)) {
          this.busy = false;
          return false;
        }

        this.preBarcode = preBarcode;
        this.modalOrders(courier, preBarcode);
      }
      this.busy = false;
    },
    betweenHour(hour, start = 0, end = 24) {
      if (hour >= start && hour < end) {
        return true;
      } else {
        return false;
      }
    },
    checkWorkingHours(courierKey) {
      // return available status
      if (!courierRules[courierKey]) return true;
      if (!courierRules[courierKey].workingHours) return true;
      // for courier working hours
      const now = moment();
      const weekDay = now.day();
      const hour = now.format("HH");
      if (!courierRules[courierKey].workingHours[weekDay])
        // วันที่ true คือเปิด ไม่ true คือปิด return false
        return false;
      if (courierRules[courierKey].workingHours[weekDay] == "all") return true;
      let start = courierRules[courierKey].workingHours[weekDay].start
        ? courierRules[courierKey].workingHours[weekDay].start.hour
        : undefined;
      let end = courierRules[courierKey].workingHours[weekDay].end
        ? courierRules[courierKey].workingHours[weekDay].end.hour
        : undefined;
      return this.betweenHour(hour, start, end);
    },
    async modalOrders(courier, typeCourier) {
      await this.getIcon(courier).then((res) => {
        this.iconUrl = res;
      });

      this.selectedCourier = courier;
      if (this.selectedCourier.rates.length > 0) {
        this.selectedCourier.rates = groupBy(
          this.selectedCourier.rates,
          "type"
        );
      }
      if (typeCourier == "prebarcode") {
        this.firstmodal =
          this.sender.name != "" ? "modal-prebarcode" : "modal-idcard";
        if (this.firstmodal == "modal-idcard") {
          this.$refs.modalSender.$refs[this.firstmodal].show();
        } else {
          this.$refs[this.firstmodal].show();
        }

        this.preBarcode = typeCourier;
      } else {
        this.firstmodal =
          this.sender.name != "" ? "model-parcel" : "modal-idcard";

        if (this.firstmodal == "modal-idcard") {
          this.$refs.modalSender.$refs[this.firstmodal].show();
        } else {
          this.$refs[this.firstmodal].show();
        }
      }
      this.setAction(this.firstmodal);
    },
    getIndex(start, index) {
      index++;
      return start + index;
    },
    sameSender() {
      if (this.isToggle == false) {
        this.from.name = this.sender.name;
        this.from.address = this.sender.address;
        this.from.state = this.sender.state;
        this.from.district = this.sender.district;
        this.from.province = this.sender.province;
        this.from.postcode = this.sender.postcode;
        this.from.tel = this.sender.tel;
        this.titleName = "ที่อยู่ตามบัตรประชาชน";
      } else {
        this.from.name = this.sameData.name;
        this.from.address = this.sameData.address;
        this.from.state = this.sameData.state;
        this.from.district = this.sameData.district;
        this.from.province = this.sameData.province;
        this.from.postcode = this.sameData.postcode;
        this.from.tel = this.sameData.tel;
        this.titleName = "ที่อยู่ร้าน";
      }
    },
    setDefaultOrigin() {
      Object.keys(this.from).forEach((key) => {
        if (this.sameData[key]) {
          this.from[key] = this.sameData[key];
        } else {
          this.from[key] = "";
        }
      });
      this.from.source = 0;
      this.isToggle = false;
    },
    close() {
      Object.keys(this.sender).forEach((key) => {
        this.sender[key] = "";
      });
      this.sender.customer_type = "0";
      this.$refs.modalSender.submitAddIdCard = false;
      this.errorBirthday = false;
      this.cod_details.isCod = false;
      this.sender.identity = false;
      this.errorIdCard = false;
      this.dropoffVRich.show = false;
      this.dropoffEasyShip.show = false;
      if (this.firstmodal == "modal-idcard") {
        this.$refs.modalSender.$refs[this.firstmodal].hide();
      } else {
        this.$refs[this.firstmodal].hide();
      }
    },
    beforeCheckbill() {
      this.checkBill.show = true;
    },
    async closeParcel() {
      return new Promise(async (resolve) => {
        if (this.addMoreOrder.isActive) {
          this.addMoreOrder.isShow = true;
        } else {
          this.$refs[this.modalparcel].hide();
          this.$refs[this.modalprebarcode].hide();
          this.setDefaultOrigin();
          this.cod_details.isCod = false;
        }
        await this.clearValueOnCloseModalParcel();
        await this.setAction(ACTION_CREATE_ORDER.index);
        return resolve(true);
      });
    },
    async clearValueOnCloseModalParcel() {
      return new Promise(async (resolve) => {
        await Object.keys(this.to).forEach((key) => {
          this.to[key] = "";
        });
        this.prerate = 0;
        this.scanBarcode = "";
        this.editorder = "";
        this.weight = "";
        this.weightKG = "";
        this.codAmount = "";
        this.width = "";
        this.length = "";
        this.height = "";
        this.tracking = "";
        this.size.boxSize = "";
        this.barcodeError = false;
        this.barcodeOk = false;
        this.errorBarcode = false;
        this.ratePreError = false;
        this.rateError = false;
        this.errorWeight = false;
        this.submitAddPrebarcode = false;
        this.submitAddShipping = false;
        this.errorCodAmount = false;
        this.errorCreateOrderByOne.status = false;
        this.errorCreateOrderByOne.msg = "";
        this.errorAlertParcel.status = false;
        this.errorAlertParcel.msg = "";
        this.errorAlertParcel.disableButton = false;
        this.draftSpecialCode = null;
        this.clearValueModalVRish();
        this.clearValueModalQuick();
        this.clearValueModalEasyShip();
        this.clearInputInsurance();
        return resolve(true);
      });
    },
    checkCodAmount() {
      this.codCondition =
        COURIERS_COD.condition[this.selectedCourier.key] ||
        COURIERS_COD.condition.default;
      if (
        this.codAmount < this.codCondition.min ||
        this.codAmount > this.codCondition.max
      ) {
        this.errorCodAmount = true;
        return false;
      } else {
        this.errorCodAmount = false;
        return true;
      }
    },
    async validatePrebarcode() {
      this.submitAddPrebarcode = true;
      this.$v.to.$touch();
      this.$v.weight.$touch();
      this.$v.scanBarcode.$touch();

      if (
        this.$v.to.$invalid ||
        this.$v.weight.$invalid ||
        this.$v.scanBarcode.$invalid
      ) {
        this.barcodeOk = false;
        return false;
      }
      if (this.barcodeError === true) {
        this.barcodeOk = false;
        this.barcodeError = true;
        return false;
      }
      if (this.weight <= 0) {
        this.barcodeOk = false;
        this.errorWeight = true;
        return false;
      }
      this.errorWeight = false;
      this.errorBarcode = false;
      this.barcodeError = false;
      const checkPrice = await this.checkPrice();
      if (checkPrice.status && checkPrice.status === false) return checkPrice;
      const addShip = await this.addShipping(checkPrice);
      if (addShip !== true) return addShip;
      return addShip;
    },
    async validateShip() {
      this.submitAddShipping = true;
      const validDes = await this.validateDestination();
      if (validDes !== true) return false;
      const checkPrice = await this.checkPrice();
      if (checkPrice.status && checkPrice.status === false) return checkPrice;
      const addShip = await this.addShipping(checkPrice);
      if (addShip !== true) return addShip;
      this.setAction(ACTION_CREATE_ORDER.index);
      if (!this.checkThemeQuick()) {
        this.clearValueOnCloseModalParcel();
      }
      return addShip;
    },
    async validateDestination() {
      this.$v.from.$touch();
      this.$v.to.$touch();
      this.$v.weight.$touch();
      this.$v.codAmount.$touch();
      this.$v.insurance.$touch();
      if (
        this.$v.from.$invalid ||
        this.$v.to.$invalid ||
        this.$v.weight.$invalid ||
        (this.insurance.isCheck && this.$v.insurance.$invalid) ||
        (this.$v.codAmount.$invalid && this.cod_details.isCod)
      ) {
        this.barcodeOk = false;
        return this.responseValidateError(this.$v);
      }
      if (this.weight <= 0) {
        this.errorWeight = true;
        return this.responseValidateError({
          weight: "weight must be more than 0",
        });
      }
      if (!this.checkCodAmount() && this.cod_details.isCod) {
        return this.responseValidateError({ cod: "cod is require" });
      }
      if (this.tracking && this.barcodeError === true) {
        this.barcodeOk = false;
        this.barcodeError = true;
        return this.responseValidateError({ cod: "barcode is require" });
      }
      let checkDes = true;
      return checkDes;
    },
    responseValidateError(data) {
      return {
        status: false,
        error: data,
      };
    },
    async checkAdressByFlash() {
      let o_province, o_district, o_state, o_postcode;

      if (this.from.source == "1") {
        o_province = this.from.province;
        o_district = this.from.district;
        o_state = this.from.state;
        o_postcode = this.from.postcode;
      } else {
        o_province = this.sameData.province;
        o_district = this.sameData.district;
        o_state = this.sameData.state;
        o_postcode = this.sameData.postcode;
      }

      let des_province = this.to.province;
      let des_district = this.to.district;
      let des_state = this.to.state;
      let des_postcode = this.to.postcode;

      let ret = null;

      await this.$http
        .post(
          API_URL + "/checkprice",
          {
            origin_province: o_province,
            origin_district: o_district,
            origin_state: o_state,
            origin_postcode: o_postcode,
            destination_province: des_province,
            destination_district: des_district,
            destination_state: des_state,
            destination_postcode: des_postcode,
            weight: this.weight,
            width: this.width,
            length: this.length,
            height: this.height,
          },
          {
            headers: {
              Token: localStorage.getItem("access_token"),
            },
          }
        )
        .then((res) => {
          let response = res.data;

          if (response.status === false) {
            ret = res.data.error;
          }
        });

      return ret;
    },
    async addShipping(price, type = TYPE_MANUAL) {
      const data = this.setCartParcelTemp(price);
      if (this.editOrdersAll) {
        this.cart.push(data);
        this.cart.splice(
          this.cart.findIndex((item) => item.check == this.editorder),
          1
        );
        this.$refs[this.modalparcel].hide();
        this.$refs[this.modalprebarcode].hide();
        this.editOrdersAll = !this.editOrdersAll;
      } else {
        if (
          this.checkThemeQuick() &&
          type == TYPE_MANUAL &&
          !this.editorder &&
          !this.checkDropoffVRich() &&
          !this.checkDropoffQuick()
        ) {
          this.isLoadingShip = true;

          if (
            this.$WALLET.status == true &&
            this.$WALLET.available_balance < data.price
          ) {
            this.checkCreditWallet(data.price);
            this.isLoadingShip = false;
            return false;
          }

          this.confirmShippingByOne(data, type);
          return true;
        } else if (this.checkDropoffVRich() || this.checkDropoffQuick()) {
          this.addCartParcelTemp(data);
          this.confirmShipping();
          this.$refs[this.modalparcel].hide();
        } else {
          this.addMoreOrder.isShow = true;
          this.addMoreOrder.isActive = true;
          this.addMoreOrder.typeCourier = this.preBarcode;
          if (this.editorder) {
            // this.addMoreOrder.order.splice(
            //   this.addMoreOrder.order.findIndex(item => item.check == this.editorder),
            //   1
            // )
            const indexOfAddMoreOrder = this.addMoreOrder.order.findIndex(
              (item) => item.check == this.editorder
            );
            this.$set(this.addMoreOrder.order, indexOfAddMoreOrder, data);
          } else {
            this.addCartParcelTemp(data);
          }
        }
      }
      this.isLoadingShip = false;
      // this.busy = false
      this.clearInputInsurance();
      return true;
    },
    checkCreditWallet(totalPrice) {
      walletPayment().then((res) => {
        this.$WALLET.available_balance = res.available_balance;
        this.$WALLET.balance = res.balance;
        this.$WALLET.peg_balance = res.peg_balance;
        if (res.available_balance < totalPrice) {
          this.alertCredit.creditPay = totalPrice;
          this.alertCredit.show = true;
        }
      });
    },
    addCartParcelTemp(data) {
      this.addMoreOrder.order.push(data);
    },
    setCartParcelTemp(listPrice = false) {
      let price = listPrice;
      if (listPrice === false) {
        price = {
          price: 0,
          rate: 0,
          fee: 0,
          key_size: 0,
          fee: 0,
          fee: 0,
        };
      }
      return {
        error: {
          status: false,
          data: [],
          msg: null,
        },
        ...(this.checkDropoffVRich()
          ? {
              dropoff_type: "VRICH_DROPOFF",
              shippop_tracking_code: this.dropoffVRich.shippopTrackingCode,
              dropoff_tracking_code: this.dropoffVRich.trackingCode,
              datetime_create_order: this.dropoffVRich.datetimeCreateOrder,
            }
          : {}),
        ...(this.checkDropoffEasyShip()
          ? {
              dropoff_type: "EASYSHIP_DROPOFF",
              dropoff_tracking_code: this.dropoffEasyShip.trackingCode,
            }
          : {}),
        ...(this.checkDropoffQuick()
          ? {
              dropoff_type: "QUICK_DROPOFF",
              shippop_tracking_code: this.dropoffQuick.shippopTrackingCode,
              dropoff_tracking_code: this.dropoffQuick.trackingCode,
              datetime_create_order: this.dropoffQuick.datetimeCreateOrder,
            }
          : {}),
        insurance: JSON.parse(JSON.stringify(this.insurance)),
        check: this.count++,
        type: "ship",
        ratetype: this.type,
        courier: this.selectedCourier,
        name: this.selectedCourier.name,
        key: this.selectedCourier.key,
        pickup_type: this.pickup_type,
        num: 1,
        special_code: price.special_code ? price.special_code : null,
        price: +price.price,
        pre_tracking: this.tracking ? this.tracking : null,
        cod_amount: this.codAmount,
        rate: price.rate,
        fee: price.fee,
        rate_remote_area: this.remote_area.rate,
        cross_price: this.crossPrice,
        parcel: {
          weight: this.weight,
          width: this.width,
          length: this.length,
          height: this.height,
          key_size: price.key_size,
          weightKG: this.weightKG,
        },
        barcode: "",
        pre_barcode: this.scanBarcode,
        refer_id: this.selectedCourier.id,
        from: {
          source: this.from.source,
          address: this.from.address,
          district: this.from.district,
          latlng: this.from.latlng,
          name: this.from.name,
          postcode: this.from.postcode,
          province: this.from.province,
          state: this.from.state,
          tel: this.from.tel,
          addressType: this.isToggle,
        },
        to: {
          address: this.to.address,
          district: this.to.state,
          latlng: this.to.latlng,
          name: this.to.name,
          postcode: this.to.postcode,
          province: this.to.province,
          state: this.to.district,
          tel: this.to.tel,
        },
      };
    },
    hasRemoteArea() {
      return (
        (this.remote_area.rate > 0 || this.crossPrice > 0) &&
        this.action !== ACTION_CREATE_ORDER.excel
      );
    },
    confirmShippingByOne(data, type = TYPE_MANUAL) {
      const order = [];
      let copyCard = JSON.parse(JSON.stringify(data));
      if (copyCard.courier) {
        delete copyCard.courier;
      }
      if (copyCard.type == "item") {
        copyCard.refer_id = copyCard.id;
      }

      order.push(copyCard);

      this.$http
        .post(
          API_URL + "/draft/order",
          {
            ...(this.orderIdByOne ? { order_id: this.orderIdByOne } : {}),
            orders: order,
            sender: {
              id_no: this.sender.id_no,
              name: this.sender.name,
              birthday: this.sender.birthday,
              tel: this.sender.tel,
              address: this.sender.address,
              state: this.sender.state,
              district: this.sender.district,
              province: this.sender.province,
              postcode: this.sender.postcode,
              customer_type: this.sender.customer_type,
              tax: this.sender.tax,
              mem_id: this.sender.mem_id,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
              Token: localStorage.getItem("access_token"),
            },
          }
        )
        .then((res) => {
          let checkError = validatePop(res);

          if (!checkError.status) {
            this.busy = false;
            this.isLoadingShip = false;

            if (
              typeof checkError.data != "undefined" &&
              checkError.data != null &&
              checkError.data.length > 0
            ) {
              this.errorCreateOrderByOne.status = true;
              this.errorCreateOrderByOne.msg = checkError.data[0].msg;
            } else {
              if (type == TYPE_EXCEL) {
                this.showErrorModal(checkError.msg);
              } else {
                this.errorCreateOrderByOne.status = true;
                this.errorCreateOrderByOne.msg = checkError.msg;
              }
            }

            return false;
          }
          let resData = res.data.data;
          this.orderIdByOne = resData.order_id;

          this.$set(data, "order_detail_id", resData.order[0].order_detail_id);
          this.$set(data, "tracking_code", resData.order[0].barcode);

          if (type == TYPE_MANUAL) {
            this.cart.push(data);
          }

          setLocalStorage.orderCart().set(this.cart);
          setLocalStorage.orderId().set(this.orderIdByOne);
          this.$WALLET.available_balance =
            res.data.data.wallet_info.available_balance;
          this.$WALLET.balance = res.data.data.wallet_info.balance;
          this.$WALLET.peg_balance = res.data.data.wallet_info.peg_balance;
          let label = this.$router.resolve({
            name: "customlabel",
            params: {
              type: "orderByOne",
              orderId: this.orderIdByOne,
              detailId: data.order_detail_id,
              label: this.label,
            },
          });
          window.open(label.href, "_blank");

          this.checkDisableCardCourier();
          this.clearValueModalParcel();
          this.clearValueOnCloseModalParcel();
          this.isLoadingShip = false;
          this.busy = false;
          this.$refs[this.modalparcel].hide();
          this.$refs[this.modalprebarcode].hide();
          // สำรองไว้ เผื่อของใหม่หาย
          // getLabelHtml( this.orderIdByOne , this.label , data.order_detail_id ).then( res => {
          //   printReceipt( res , 500 );
          //   this.checkDisableCardCourier();
          //   this.clearValueModalParcel()
          //   this.clearValueOnCloseModalParcel();
          //   this.isLoadingShip = false;
          //   this.busy = false;
          //   this.$refs[this.modalparcel].hide()
          //   this.$refs[this.modalprebarcode].hide()
          // })
        })
        .catch((error) => {
          console.log("error", error);
          this.isLoadingShip = false;
          this.busy = false;
          this.showErrorModal(
            " พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #011 "
          );
        });
    },
    async printLabel(order_detail_id) {
      const label = await getLabelHtml(
        this.orderIdByOne,
        this.label,
        order_detail_id
      );
      const win = window.open("", "_blank");
      win.document.write(label);
    },
    printLabelDropoff(trackingCodeSP, typeDropoff) {
      const win = window.open("", "_blank");
      getLabelHtmlByTracking(this.label, trackingCodeSP, typeDropoff).then(
        (res) => {
          win.document.write(res.html);
        }
      );
    },
    switchPrintLabel(order) {
      if (order.order_detail_id) {
        let label = this.$router.resolve({
          name: "customlabel",
          params: {
            type: "orderByOne",
            orderId: this.orderIdByOne,
            detailId: order.order_detail_id,
            label: this.label,
          },
        });
        window.open(label.href, "_blank");
      } else if (
        order.hasOwnProperty("dropoff_type") &&
        (order.dropoff_type == "VRICH_DROPOFF" ||
          order.dropoff_type == "QUICK_DROPOFF")
      ) {
        this.printLabelDropoff(order.shippop_tracking_code, order.dropoff_type);
      } else {
        this.busy = true;
        this.confirmShippingByOne(order, "excel");
      }
    },
    checkBeforeRemoveTotal(check) {
      if (this.checkThemeQuick()) {
        this.cancelBeforeRemoveTotal(check);
      } else {
        this.removeTotal(check);
      }
    },
    confirmShipping() {
      this.addMoreOrder.isShow = false;
      this.addMoreOrder.isActive = false;
      this.cart.push(...this.addMoreOrder.order);
      const dataToSave = {
        sender: this.sender, // แทนที่ด้วยข้อมูลของผู้ส่ง
        cart: this.cart,
      };

      localStorage.setItem("list_draft", JSON.stringify(dataToSave));

      if (this.checkThemeQuick()) {
        setLocalStorage.orderCart().set(this.cart);
      }
      if (
        this.addMoreOrder.order[0].hasOwnProperty("dropoff_type") &&
        (this.addMoreOrder.order[0].dropoff_type == "VRICH_DROPOFF" ||
          this.addMoreOrder.order[0].dropoff_type == "QUICK_DROPOFF")
      ) {
        this.clearValueOnCloseModalParcel();
      }
      this.checkDisableCardCourier();
      this.addMoreOrder.order = [];
      this.clearValueModalParcel();
      console.log("cart=>", this.cart);
    },
    checkDisableCardCourier() {
      this.cart.forEach((item, index) => {
        if (item.type == "ship") {
          if (this.filterCheckDropoffVRich) {
            this.lockpre = "lock";
            this.lock = "lock";
            this.lockCourierGen = "lock";
            this.lockDropoffShippop = "lock";
            this.lockDropoffEasyShip = "lock";
            this.lockKerryDropoff = "lock";
            this.lockDropoffQuick = "lock";
          } else if (this.filterCheckDropoffQuick) {
            this.lockpre = "lock";
            this.lock = "lock";
            this.lockCourierGen = "lock";
            this.lockDropoffShippop = "lock";
            this.lockDropoffVRich = "lock";
            this.lockDropoffEasyShip = "lock";
            this.lockKerryDropoff = "lock";
          } else if (this.filterCheckKerryDropoff) {
            this.lockpre = "lock";
            this.lock = "lock";
            this.lockCourierGen = "lock";
            this.lockDropoffShippop = "lock";
            this.lockDropoffVRich = "lock";
            this.lockDropoffQuick = "lock";
            this.lockDropoffEasyShip = "lock";
          } else if (
            this.selectedCourier.prebarcode == 1 &&
            this.selectedCourier.shippop == 1
          ) {
            this.lock = "lock";
            this.lockDropoffShippop = "lock";
            this.lockDropoffVRich = "lock";
            this.lockDropoffQuick = "lock";
            this.lockDropoffEasyShip = "lock";
            this.lockKerryDropoff = "lock";
          } else if (
            this.selectedCourier.prebarcode == 0 &&
            this.selectedCourier.shippop == 1
          ) {
            this.lockpre = "lock";
            this.lockDropoffShippop = "lock";
            this.lockDropoffVRich = "lock";
            this.lockKerryDropoff = "lock";
            this.lockDropoffQuick = "lock";
          } else {
          }
        }
      });
    },
    clearValueModalParcel() {
      Object.keys(this.to).forEach((key) => {
        this.to[key] = "";
      });
      this.setDefaultOrigin();
      this.cod_details.isCod = false;
      this.editorder = "";
      this.scanBarcode = "";
      this.weight = "";
      this.weightKG = "";
      this.codAmount = "";
      this.width = "";
      this.length = "";
      this.height = "";
      this.tracking = "";
      this.keyBox = "";
      this.size.boxSize = "";
      this.rateError = false;
      this.clearValueModalVRish();
      this.clearValueModalQuick();
      this.clearValueModalEasyShip();
      this.submitAddPrebarcode = false;
      this.submitAddShipping = false;
      // this.$refs[this.modalparcel].hide();
      // this.$refs[this.modalprebarcode].hide();
    },
    clearValueModalVRish() {
      if (this.checkDropoffVRich()) {
        this.dropoffVRich.show = false;
        this.dropoffVRich.trackingCode = "";
        this.dropoffVRich.shippopTrackingCode = "";
      }
    },
    clearValueModalEasyShip() {
      if (this.checkDropoffEasyShip()) {
        this.dropoffEasyShip.show = false;
        this.dropoffEasyShip.trackingCode = "";
      }
    },
    clearValueModalQuick() {
      if (this.checkDropoffQuick()) {
        this.dropoffQuick.show = false;
        this.dropoffQuick.trackingCode = "";
        this.dropoffQuick.shippopTrackingCode = "";
      }
    },
    async itemPreRate() {
      this.busy = true;

      if (this.checkUntiKG()) {
        this.weight = this.weightKG * 1000;
      }

      const price = await this.itemPrice();
      this.busy = false;
      this.errorWeight = false;
      this.rateError = false;
      this.ratePreError = false;
      if (!this.weight || this.weight == 0) {
        this.errorWeight = true;
        this.prerate = 0;
      } else if (price.status === false && price.type == "weight") {
        this.rateError = true;
        this.ratePreError = true;
        this.errorWeight = false;
      } else if (price.status === false && price.type == "dimension") {
        this.rateError = true;
        this.prerate = 0;
        return false;
      } else {
        this.prerate = +price.price;
        this.errorWeight = false;
        this.rateError = false;
        this.ratePreError = false;
      }
    },
    onChangeParcelDetails() {
      return [
        ACTION_CREATE_ORDER.modalParcel,
        ACTION_CREATE_ORDER.modalPrebarcode,
      ].includes(this.action);
    },
    changePostcode(postcode, pointer) {
      if (
        this.weight > 0 &&
        postcode.toString().length == 5 &&
        this.onChangeParcelDetails()
      ) {
        this.itemPreRate();
      }
    },
    changeProvince(event) {
      if (
        this.weight > 0 &&
        this.to.postcode > 5 &&
        event &&
        this.onChangeParcelDetails()
      ) {
        this.itemPreRate();
      }
    },
    clearInputValidateDimension() {
      this.validate = {
        modalParcel: {
          checkDimension: {
            status: true,
            msg: "",
          },
          dimension: {
            width: {
              status: true,
              msg: "",
            },
            length: {
              status: true,
              msg: "",
            },
            height: {
              status: true,
              msg: "",
            },
          },
        },
      };
    },
    async createOrderByExcel(data) {
      this.addMoreOrder.isActive = true;
      await this.closeParcel();
      this.busy = true;
      this.checkErrorCreateOrderByExcel = data.status;
      await this.setAction(ACTION_CREATE_ORDER.excel);
      for (const item of data.data) {
        try {
          const checkPrice = await this.autoCheckPrice(item);
        } catch (err) {
          let _order = this.addMoreOrder.order;
          const lastIndexItem = _order.length - 1;
          _order[lastIndexItem].error.status = true;
          _order[lastIndexItem].error.data.push(err.error);
        }
      }
      this.addMoreOrder.isShow = true;
      this.addMoreOrder.isActive = true;
      this.addMoreOrder.typeCourier = this.preBarcode;
      await this.clearValueOnCloseModalParcel();
      this.busy = false;
    },
    async setAction(event) {
      return new Promise((resolve) => {
        this.action = event;
        return resolve(this.action);
      });
    },
    setDestinations(item) {
      const key = Object.keys(item);
      this.to.name = item[key[0]];
      this.to.tel = item[key[1]];
      this.to.address = item[key[2]];
      this.to.state = item[key[3]];
      this.to.district = item[key[4]];
      this.to.province = item[key[5]];
      this.to.postcode = item[key[6]];
      this.weight = this.checkUntiKG() ? item[key[7]] * 1000 : item[key[7]];

      if (this.checkUntiKG()) {
        this.weightKG = item[key[7]];
      }

      this.width = item[key[8]];
      this.length = item[key[9]];
      this.height = item[key[10]];
      if (this.cod_details.isCod) {
        const cod = isNaN(item[key[11]]) ? null : item[key[11]];
        this.codAmount = cod;
      }
      this.keyBox = item[key[12]];
    },
    async autoCheckPrice(item) {
      return new Promise(async (resolve, reject) => {
        this.setDestinations(item);

        const addCart = this.setCartParcelTemp();
        this.addCartParcelTemp(addCart);
        const checkDes = await this.validateDestination();
        if (checkDes.status === false) return reject(checkDes);

        const checkPrice = await this.checkPrice();
        if (checkPrice.hasOwnProperty("status") && checkPrice.status === false)
          return reject(checkPrice);

        let _order = this.addMoreOrder.order;
        const lastIndexItem = _order.length - 1;
        this.addMoreOrder.order.splice(lastIndexItem, 1);
        const addShip = await this.addShipping(checkPrice, TYPE_EXCEL);
        if (addShip !== true) return reject(addShip);

        return resolve(addCart);
      });
    },
    async checkPrice() {
      const TYPR_DIM = "dimension";
      const price = await this.itemPrice();
      if (price.status === false) {
        this.ratePreError = true;
        this.rateError = true;
        this.errorWeight = false;
        this.isLoadingShip = false;
        return this.responseValidateError({
          ratePreError: this.ratePreError,
          rateError: this.rateError,
          errorWeight: this.errorWeight,
          isLoadingShip: this.isLoadingShip,
        });
      }
      if (price.status === false && price.type === TYPR_DIM) {
        this.isLoadingShip = false;
        return this.responseValidateError(price);
      }
      await this.checkRemoteArea(price.remote_area);
      this.crossPrice = price.cross_price;
      if (this.hasRemoteArea()) {
        this.$bvModal.show("modal-remote-area");
      }
      this.isLoadingShip = false;
      return price;
    },
    async checkRemoteArea(remoteArea) {
      if (
        !courierRules.extraCouriers.includes(this.selectedCourier.key) &&
        remoteArea < 1
      ) {
        this.remote_area.rate = remoteArea;
        return remoteArea;
      }

      let addressRemote = [
        this.to.state,
        this.to.district,
        this.to.province,
        this.to.postcode,
      ].join(" ");
      this.isLoadingShip = true;
      await COURIER.setCourier(this.selectedCourier.key)
        .checkRemoteAreaByCorrectorDest(addressRemote)
        .then((res) => {
          this.isLoadingShip = false;
          if (res) {
            this.remote_area.rate = remoteArea;
            if (
              this.selectedCourier.key == "BEST" &&
              remoteArea == 80 &&
              new Date() < new Date("2022-01-13 00:00:00")
            ) {
              this.remoate_area.rate = 100;
            }
          } else {
            this.remote_area.rate = 0;
          }
        });
      if (this.selectedCourier.key == "CJLX" && this.remote_area.rate <= 0) {
        let addressRemoteOrigin =
          this.from.source == "1"
            ? [
                this.from.state,
                this.from.district,
                this.from.province,
                this.from.postcode,
              ].join(" ")
            : [
                this.sameData.state,
                this.sameData.district,
                this.sameData.province,
                this.sameData.postcode,
              ].join(" ");
        let postcodeOrigin =
          this.from.source == "1" ? this.from.postcode : this.sameData.postcode;
        this.isLoadingShip = true;
        await COURIER.setCourier(this.selectedCourier.key)
          .checkRemoteAreaByCorrectorOrigin(addressRemoteOrigin, postcodeOrigin)
          .then((res) => {
            this.isLoadingShip = false;
            this.remote_area.rate = res;
          });
      }
      return this.remote_area.rate;
    },
    async itemPrice() {
      this.clearInputValidateDimension();
      let fromPostcode = this.sameData.postcode;
      let key_size = this.keyBox;
      let courierCode = "SPGEN";
      let isSkipDimension = false;
      if (this.from.source == "1") {
        fromPostcode = this.from.postcode;
      }
      const listSpecialCode = [];
      let checkZone = {
        fromPostcode: fromPostcode,
        toPostcode: this.to.postcode,
      };
      checkZone.listSpecialCode = listSpecialCode;
      checkZone.specialCode = this.draftSpecialCode;
      checkZone.courierPromotion = false;

      this.errorAlertParcel.status = false;
      this.errorAlertParcel.msg = "";
      this.errorAlertParcel.disableButton = false;

      let courierDetails = await COURIER.setCourier(courierCode).getZone(
        checkZone
      );
      let special_code = null;
      this.type = courierDetails.rate_type;
      let selected_rate = this.selectedCourier.rates[this.type];

      if (this.type < 0) {
        return {
          status: false,
          type: "weight",
        };
      }
      const weight = +this.weight;
      let index = -1;
      let courierRates = selected_rate;
      let size = {
        width: this.width,
        length: this.length,
        height: this.height,
      };
      let checkWeight = {
        weight: weight,
        index: index,
        size: size,
        keySize: key_size, //for SCG, SCGC, SCGF
      };

      let resWeight = COURIER.setCourier(courierCode).checkWeight(
        courierRates,
        checkWeight,
        this.validate.modalParcel
      );

      index = resWeight.index;

      if (index > -1) {
        if (
          courierRates[index].dimension &&
          courierRates[index].dimension != 0
        ) {
          let resDimension = COURIER.setCourier(courierCode).checkDimension(
            courierRates,
            {
              index: index,
              size: size,
            },
            this.validate.modalParcel
          );

          if (resDimension.status == false) {
            return {
              status: false,
              type: "dimension",
            };
          } else {
            index = resDimension.data.index;
          }
        }
      }

      if (index <= -1) {
        this.prerate = 0;
        return {
          status: false,
          type: "weight",
        };
      }
      return {
        price: courierRates[index].price,
        rate: courierRates[index].rate,
        fee: courierRates[index].fee,
        remote_area: courierDetails.rate_remote_area,
        cross_price: courierDetails.cross_price,
        key_size: key_size,
        special_code: special_code,
      };
    },
    getStashSpecialCode() {
      let stash = [];

      if (this.cartShipping.length > 0) {
        for (const index in this.cartShipping) {
          let _cart = this.cartShipping[index];
          if (_cart.special_code && !stash.includes(_cart.special_code)) {
            stash.push(_cart.special_code);
          }
        }
      }

      if (this.addMoreOrder.order.length > 0) {
        for (const index in this.addMoreOrder.order) {
          let _tmp = this.addMoreOrder.order[index];
          if (_tmp.special_code && !stash.includes(_tmp.special_code)) {
            stash.push(_tmp.special_code);
          }
        }
      }
      return stash;
    },
    modalConfirmReset() {
      let msgAlert = "คุณต้องการจะเปิดบิลใหม่";

      if (this.$THEME.btnCancelBill && !this.idorder && this.cart.length) {
        msgAlert =
          "รายการที่คุณมีอยู่ขณะนี้จะถูกยกเลิก คุณแน่ใจที่จะยกเลิกรายการทั้งหมด ?";
      }

      this.$bvModal
        .msgBoxConfirm(`${msgAlert} `, {
          title: "กรุณายืนยัน",
          size: "sm",
          buttonSize: "sm",
          okVariant:
            this.$THEME.btnCancelBill && !this.idorder && this.cart.length
              ? "danger"
              : "success",
          okTitle: "ยืนยัน",
          cancelTitle: "ยกเลิก",
          contentClass: "modal-confirm",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            if (this.checkThemeQuick() && !this.idorder) {
              this.isLoadingNewBill = true;
              let orderDetailId = [];

              this.cart.forEach((order) => {
                if (order.type === "ship" && order.key !== "GEN") {
                  orderDetailId.push(order.order_detail_id);
                }
              });

              cancelOrderByOne(this.orderIdByOne, orderDetailId).then(
                (results) => {
                  if (results.status) {
                    const countListFail = results.data.list_fail.length;
                    if (countListFail > 1) {
                      this.isLoadingNewBill = false;
                      this.showErrorModal(
                        `ไม่สามารถยกเลิกรายการได้ ${results.data.receipt_id}`
                      );
                      return false;
                    }
                    this.reStartOrderByOne();
                    this.reset();
                  } else if (results == "newbill") {
                    this.reStartOrderByOne();

                    if (!this.filterCheckKerryDropoff) {
                      this.reset();
                    }
                  } else {
                    if (results.error.code == "ORDER_ID_NOT_FOUND") {
                      this.reStartOrderByOne();
                      this.reset();
                    }
                  }
                }
              );
            } else {
              this.reStartOrderByOne();

              if (!this.filterCheckKerryDropoff || this.idorder) {
                this.reset();
              }
            }
          }
        });
    },
    reset() {
      location.reload();
    },
    formatDate() {
      this.errorBirthday = false;
      let v = this.sender.birthday;
      if (v.match(/^\d{2}$/) !== null) {
        this.sender.birthday = v + "/";
      } else if (v.match(/^\d{2}\/\d{2}$/) !== null) {
        this.sender.birthday = v + "/";
      }
    },
    checkIdNo() {
      this.sender.id_no = swapBarcode(this.sender.id_no);
    },
    checkBarcode() {
      if (this.scanBarcode) {
        this.scanBarcode = swapBarcode(this.scanBarcode);
        let validateBarcode = PREBARCODE_PATTERN[this.selectedCourier.key].test(
          this.scanBarcode
        );
        if (
          validateBarcode === false ||
          this.checkBarcodeInPurchase(this.scanBarcode, "pre_barcode") >= 0
        ) {
          this.barcodeOk = false;
          this.errorBarcode = true;
          this.scanBarcode = "";
          return false;
        }
        this.getBarcode(this.scanBarcode);
      }
      if (this.tracking) {
        this.tracking = swapBarcode(this.tracking);
        let validateTracking = validCourier(
          this.shop_id,
          this.selectedCourier.id,
          this.tracking
        );
        if (
          validateTracking === false ||
          this.checkBarcodeInPurchase(this.tracking, "pre_tracking") >= 0
        ) {
          this.barcodeOk = false;
          this.errorBarcode = true;
          this.tracking = "";
          this.scanBarcode = "";
          return false;
        }
        this.getBarcode(this.tracking);
      }
    },
    checkBarcodeInPurchase(barcode = "", type = "") {
      if (this.cart.length > 0) {
        return this.cart.findIndex((parcel) => {
          if (parcel[type] !== "undefined") {
            return parcel[type] == barcode;
          } else {
            return -1;
          }
        });
      }
      if (this.addMoreOrder.order.length > 0) {
        return this.addMoreOrder.order.findIndex((parcel) => {
          if (parcel[type] !== "undefined") {
            return parcel[type] == barcode;
          } else {
            return -1;
          }
        });
      }
      return -1;
    },
    getBarcode(scancode) {
      this.$http
        .get(API_URL + "/check/" + scancode, {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
        })
        .then((res) => {
          if (res.data.status == false) {
            this.barcodeOk = false;
            this.barcodeError = true;
            this.scanBarcode = "";
            this.tracking = "";
          } else {
            this.barcodeError = false;
            this.errorBarcode = false;
            this.barcodeOk = true;
            if (this.scanBarcode) {
              this.$nextTick(() =>
                this.$refs.toName.$refs.declared_value.focus()
              );
            }
          }
        })
        .catch(() => {
          this.showErrorModal(
            "ไม่สามารถเช็คเลข Prebarcode ได้ กรุณาลองใหม่อีกครั้ง"
          );
        });
    },
    focusMyElement() {
      this.$refs.focusWeight.focus();
    },
    isAdmin() {
      return this.userlogin.role === "admin";
    },
    showNotiModal(msgBody, msgColor = "", setStyle = {}) {
      const h = this.$createElement;
      let style = {
        text: (setStyle.text ? setStyle.text : "text-center") + " mt-2",
        emphasize:
          (setStyle.emphasize
            ? setStyle.emphasize
            : "text-center text-danger") + " mb-0",
      };
      if (typeof msgBody === "object") {
        this.$bvModal.msgBoxOk(
          h("div", [
            h(
              "div",
              {
                class: ["d-flex justify-content-center"],
              },
              [
                h("i", {
                  class: ["fa fa-exclamation-circle text-warning"],
                  style: "font-size:90px;",
                }),
              ]
            ),
            h("h4", { class: [style.text] }, [msgBody[0]]),
            h("h4", { class: [style.text] }, [msgBody[1]]),
            h("h4", { class: [style.text] }, [msgBody[2]]),
            h("h4", { class: [style.text] }, [msgBody[3]]),
            h("h4", { class: [style.text] }, [msgBody[4]]),
            h("h4", { class: [style.emphasize] }, [msgColor]),
          ]),
          {
            title: h("div", {
              domProps: {
                innerHTML: '<h3 style="color:black;">ข้อความแจ้งเตือน</h3>',
              },
            }),
            size: "sm",
            buttonSize: "sm",
            okVariant: "warning",
            okTitle: "ยืนยัน",
            contentClass: "modal-warning",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          }
        );
      } else
        this.$bvModal.msgBoxOk(
          h("div", [
            h(
              "div",
              {
                class: ["d-flex justify-content-center"],
              },
              [
                h("i", {
                  class: ["fa fa-exclamation-circle text-warning"],
                  style: "font-size:90px;",
                }),
              ]
            ),
            h("h4", { class: ["text-center mt-2"] }, [msgBody]),
            h("h4", { class: ["text-center text-danger mb-0"] }, [msgColor]),
          ]),
          {
            title: h("div", {
              domProps: {
                innerHTML: '<h3 style="color:black;">ข้อความแจ้งเตือน</h3>',
              },
            }),
            size: "sm",
            buttonSize: "sm",
            okVariant: "warning",
            okTitle: "ยืนยัน",
            contentClass: "modal-warning",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          }
        );
    },
    checkStatusShop() {
      return new Promise((resolve) => {
        this.$http
          .get(API_URL + "/shop/noti", {
            headers: {
              Token: localStorage.getItem("access_token"),
            },
          })
          .then((res) => {
            let checkError = validatePop(res);
            if (!checkError.status) {
              if (checkError.notices == "token is expired") {
                this.$router.push("/logout");
              }
              this.showErrorModal(checkError.msg);
              this.busy = false;
              return false;
            }
            resolve(res);
          })
          .catch(() => {
            this.showErrorModal("พบปัญหาการเชื่อมต่อ กรุณาติดต่อ...");
          });
      });
    },
    checkThemeQuick() {
      return this.$THEME.name == "quickexpress";
    },
    checkUntiKG() {
      return this.$THEME.unitKG;
    },
    checkDropoffVRich() {
      return this.dropoffVRich.show == true;
    },
    checkDropoffEasyShip() {
      return this.dropoffEasyShip.show == true;
    },
    checkDropoffQuick() {
      return this.dropoffQuick.show == true;
    },
    checkDisableInputDropoff() {
      return this.checkDropoffVRich() || this.checkDropoffQuick();
    },
    checkShowWeightCart(order) {
      return (
        order.hasOwnProperty("parcel") &&
        (this.checkUntiKG()
          ? order.parcel.hasOwnProperty("weightKG")
          : order.parcel.hasOwnProperty("weight"))
      );
    },
    showSuccessModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "SUCCESS",
        size: "sm",
        buttonSize: "sm",
        okVariant: "success",
        okTitle: "ตกลง",
        contentClass: "modal-success",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true,
      });
    },
    showErrorModal(msgBody, msgTitle = "ลองอีกครั้ง") {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "ERROR",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: msgTitle,
        contentClass: "modal-errors",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true,
      });
    },
  },
  computed: {
    checkErrorCreateOrderByExcel: {
      get() {
        return this.orderExcel.error;
      },
      set(value) {
        if (value === true || value.status === true) {
          return (this.orderExcel.error = []);
        }
        let res = {
          header: null,
          body: null,
        };
        const typeInvalidExcel = "invaid_format";
        const typeInvalidLengthExcel = "invaid_length";
        value.error.forEach((error) => {
          if (error.type === typeInvalidExcel) {
            res.header = "รูปแบบไฟล์ไม่ถูกต้อง";
            res.body = error.msg;
          } else if (error.type === typeInvalidLengthExcel) {
            res.header = "ทำรายการเกินจำนวนออเดอร์ที่กำหนด";
            res.body = error.msg;
          }
          this.orderExcel.error.push(res);
        });
      },
    },
    action: {
      get() {
        return this.actioned;
      },
      set(val) {
        this.actioned = val;
      },
    },
    isVisibleShabuVoucher() {
      if (this.shubuVoucherAllow.hasOwnProperty("SHABU")) {
        let shopShabuAllow = this.shubuVoucherAllow.SHABU.SHOP.find((id) => {
          return this.shop_id == id;
        });
        if (shopShabuAllow) {
          return true;
        } else {
          return false;
        }
      }
    },
    issetParcelInsurance() {
      return this.insurance.listRates.length > 0;
    },
    checkErrorParcelInsurance() {
      let res = {
        status: true,
        data: [],
      };
      if (
        this.insurance.isCheck &&
        this.$v.insurance.declared_value.$error &&
        this.submitAddShipping
      ) {
        res.data.push("กรุณากรอก มูลค่าสินค้า");
      } else if (this.insurance.isCheck && this.insurance.error.status) {
        res.data.push(this.insurance.error.msg);
      } else {
        res.status = false;
        res.data = [];
      }
      return res;
    },
    checkErrorSeletedParcelInsurance() {
      let res = {
        status: true,
        data: [],
      };
      if (
        this.insurance.isCheck &&
        this.$v.insurance.remark.$error &&
        this.submitAddShipping
      ) {
        res.data.push("กรุณาเลือกประเภทสินค้า");
      } else {
        res.status = false;
        res.data = [];
      }
      return res;
    },
    showPreRate() {
      return (
        Number(+this.prerate) +
        +(this.insurance ? this.insurance.listPrice.price : 0)
      );
    },
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    // total คิดเงิน
    total() {
      return this.cart.reduce((total, product) => {
        let remote_area = 0;
        let crossPrice = 0;
        if (product.rate_remote_area) {
          remote_area = product.rate_remote_area;
        }
        if (product.cross_price) {
          crossPrice = product.cross_price;
        }
        return (
          total +
          Number(product.num) * Number(product.price) +
          Number(remote_area) +
          Number(crossPrice) +
          Number(product.insurance ? product.insurance.listPrice.price : 0)
        );
      }, 0);
    },
    totalCourierPrice() {
      return this.cartShipping.reduce((total, itemShip) => {
        return (
          total +
          Number(itemShip.num) * Number(itemShip.price) +
          Number(itemShip.insurance ? itemShip.insurance.listPrice.price : 0)
        );
      }, 0);
    },
    totalShipping() {
      return this.cartShipping.reduce((total, itemShip) => {
        let remote_area = 0;
        let crossPrice = 0;
        if (itemShip.rate_remote_area) {
          remote_area = itemShip.rate_remote_area;
        }
        if (itemShip.cross_price) {
          crossPrice = itemShip.cross_price;
        }
        return (
          total +
          Number(itemShip.num) * Number(itemShip.price) +
          Number(remote_area) +
          Number(crossPrice) +
          Number(itemShip.insurance ? itemShip.insurance.listPrice.price : 0)
        );
      }, 0);
    },
    culculateSize() {
      return [this.width, this.length, this.height].reduce((sum, num) => {
        return sum + Number(num);
      }, 0);
    },
    cartItem() {
      return this.cart.filter((item) => {
        return item.type === "item";
      });
    },
    cartShipping() {
      return this.cart.filter((item) => {
        return item.type === "ship";
      });
    },
    cartService() {
      return this.cart.filter((item) => {
        return item.type === "service";
      });
    },
    cartDropoffShippop() {
      return this.cart.filter((item) => {
        return item.type === DROPOFF_SP;
      });
    },
    cartInsurance() {
      return this.cart.filter((item) => {
        return item.type === "insurance";
      });
    },
    cartEVoucher() {
      return this.cart.filter((item) => {
        return item.type === "eVoucher";
      });
    },
    cartZendai() {
      return this.cart.filter((item) => {
        return item.type === "zendai";
      });
    },
    cartKerryDropoff() {
      return this.cartShipping.filter((order) => {
        return (
          order.hasOwnProperty("dropoff_type") &&
          order.dropoff_type == "KERRY_DROPOFF"
        );
      });
    },
    cartDropoffVRich() {
      if (this.checkThemeQuick()) {
        return this.cartShipping.filter((order) => {
          return (
            order.hasOwnProperty("dropoff_type") &&
            order.dropoff_type == "VRICH_DROPOFF"
          );
        });
      }
      return false;
    },
    cartDropoffQuick() {
      if (this.checkThemeQuick()) {
        return this.cartShipping.filter((order) => {
          return (
            order.hasOwnProperty("dropoff_type") &&
            order.dropoff_type == "QUICK_DROPOFF"
          );
        });
      }
      return false;
    },
    courierFilter() {
      return this.couriers.filter((item) => {
        return item.title
          .toLowerCase()
          .includes(this.searchCourier.toLowerCase());
      });
    },
    productFilter() {
      return this.products.filter((item) => {
        return item.name
          .toLowerCase()
          .includes(this.searchProduct.toLowerCase());
      });
    },
    identityTxtCod() {
      let msg = "สามารถใช้ COD ได้";
      if (!this.sender.identity) {
        msg = "ไม่สามารถใช้ COD ได้";
      }
      return msg;
    },
    lockDimension() {
      let res = false;
      if (
        courierRules.lockDimensionCouriers.includes(this.selectedCourier.key)
      ) {
        res = true;
      }
      return res;
    },
    lockWeight() {
      let res = false;
      if (courierRules.lockWeightCouriers.includes(this.selectedCourier.key)) {
        res = true;
      }
      return res;
    },
    cloneAddressTo() {
      return JSON.parse(JSON.stringify(this.to));
    },
    cloneAddressFrom() {
      return JSON.parse(JSON.stringify(this.from));
    },
    checkDateEVoucher() {
      if (new Date().getTime() < new Date("2022-01-01 00:00:00").getTime()) {
        return true;
      }
      return false;
    },
    filterCheckOrderDetailId() {
      if (this.checkThemeQuick()) {
        return (
          this.cartShipping.filter((order) => {
            return !order.hasOwnProperty("order_detail_id");
          }).length > 0
        );
      }

      return false;
    },
    filterCheckDropoffVRich() {
      if (this.checkThemeQuick()) {
        return (
          this.cartShipping.filter((order) => {
            return (
              order.hasOwnProperty("dropoff_type") &&
              order.dropoff_type == "VRICH_DROPOFF"
            );
          }).length > 0
        );
      }

      return false;
    },
    filterCheckDropoffQuick() {
      if (this.permission.dropoffQuick) {
        return (
          this.cartShipping.filter((order) => {
            return (
              order.hasOwnProperty("dropoff_type") &&
              order.dropoff_type == "QUICK_DROPOFF"
            );
          }).length > 0
        );
      }

      return false;
    },
    filterCheckKerryDropoff() {
      if (this.$THEME.dropoffKerry || this.permission.kerryDropoff) {
        return (
          this.cartShipping.filter((order) => {
            return (
              order.hasOwnProperty("dropoff_type") &&
              order.dropoff_type == "KERRY_DROPOFF"
            );
          }).length > 0
        );
      }

      return false;
    },
    filterCheckEasyShip() {
      if (this.checkPermissionDropoffEasyShip()) {
        return (
          this.cartShipping.filter((order) => {
            return (
              order.hasOwnProperty("dropoff_type") &&
              order.dropoff_type == "EASYSHIP_DROPOFF"
            );
          }).length > 0
        );
      }
      return false;
    },
    filteredCartShippingByRecipient() {
      return this.cartShipping.filter((order) => {
        return (
          order.to.name
            .toLowerCase()
            .includes(this.search.recipient.toLowerCase()) ||
          order.to.tel
            .toLowerCase()
            .includes(this.search.recipient.toLowerCase())
        );
      });
    },
  },
  watch: {
    busy: function () {
      let prod = this.productAvoid;
      if (!this.busy && this.firstLoad) {
        prod.show = true;
        prod.isBanner = true;
        prod.key = "banner";
      }
    },
    cloneAddressTo: function (oldVal, newVal) {
      if (this.selectedCourier.key == "FLE") {
        for (let key in oldVal) {
          if (
            oldVal[key] != newVal[key] &&
            this.validateAddress.to[key] &&
            this.validateAddress.to[key].status
          ) {
            this.validateAddress.to[key].status = false;
            this.validateAddress.to[key].msg = null;
          }
        }
      }
    },
    cloneAddressFrom: function (oldVal, newVal) {
      if (this.selectedCourier.key == "FLE") {
        for (let key in oldVal) {
          if (
            oldVal[key] != newVal[key] &&
            this.validateAddress.from[key] &&
            (this.validateAddress.from[key].status ||
              this.errorCreateOrderByOne.status)
          ) {
            this.validateAddress.from[key].status = false;
            this.validateAddress.from[key].msg = null;

            this.errorCreateOrderByOne.status = false;
            this.errorCreateOrderByOne.msg = null;
          }
        }
      }
    },
    "to.postcode": function (postcode) {
      this.changePostcode(postcode, "to");
    },
    "from.postcode": function (postcode) {
      this.changePostcode(postcode, "from");
    },
    "from.source": function () {
      this.itemPreRate();
    },
    "from.province": function (event) {
      this.changeProvince(event);
    },
    "to.province": function (event) {
      this.changeProvince(event);
    },
  },
};
</script>
<style lang="scss" scoped>
.tr-error-after-create-order-details {
  color: #fb6340;
}

.tr-error-after-create-order-msg {
  background: #ff00000f;
  color: #fb6340;
  font-weight: bold;
}
</style>
